<template>
    <form @submit.prevent>

        <div class="settings_right filingfee_list remainder_list">
            <div class="list-items-wrap "> 
                <div class="subtypes_list">
                    <ul>
                            <li v-for="(item, index) in reminderTabs" :key="index">
                            <a :class="{ activetype:activeTab == checkProperty(item, 'selectedTab') }"  @click="setActive(item)"><span>{{ item['name'] }}</span></a>
                            </li>
                        </ul>
                </div>
                <div class="list-items-cnt">
                    <div class="list-items-in">
                        <div class="form_section pad0 marb15">
                            <div class="form-container settings-form">
                                <div class="vx-row">
                                    <template v-if="activeTab=='BeneficiaryProfile'">
                                        
                                        <div class="vx-col w-full">
                                                    <h3 class="small-header">Submit Questionnaire</h3>
                                                    <form @submit.prevent data-vv-scope="lcaSubAndQuestNotSubBriefDays">
                                                    <template
                                                        v-for="(item, indexx) in config['reminders']['lcaSubAndQuestNotSubBriefDays']['config'] ">
                                                        <div class="vx-col w-full">
                                                            <div class="form_group">
                                                                <div class="perm_application_delete">
                                                                    <p><vs-input :maxLength="3"
                                                                            @blur="checkInputI140Value(item, indexx, 'lcaSubAndQuestNotSubBriefDays')"
                                                                            oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                            class="textfiled"
                                                                            :name="'lcaSubAndQuestNotSubBriefDays' + indexx"
                                                                            icon-pack="feather" v-validate="'required'"
                                                                            data-vv-as="Please enter data" icon-after
                                                                            v-model="item.days" /> days after LCA is submitted and
                                                                        questionnaire is not submitted</p>
                                                                    <span v-if="checkProperty(item, 'showError')"
                                                                        class="text-danger text-sm">Days should be greater than last
                                                                        entry </span>
                                                                    <span class="text-danger text-sm"
                                                                        v-show="errors.has('lcaSubAndQuestNotSubBriefDays.lcaSubAndQuestNotSubBriefDays' + indexx) && !checkProperty(item, 'showError')">
                                                                        Days required </span>
                                                                    <div class="delete"
                                                                        v-if="checkProperty(config['reminders']['lcaSubAndQuestNotSubBriefDays'], 'config', 'length') > 1"
                                                                        @click="removefilingfee('lcaSubAndQuestNotSubBriefDays', indexx)">
                                                                        <a>
                                                                            <img src="@/assets/images/main/delete-row-img.svg" />
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <vs-row class="more_btn_wrap application_btn"
                                                        v-if="showMoreBtn('lcaSubAndQuestNotSubBriefDays')">
                                                        <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                            vs-align="center">
                                                            <a @click="addMoreKeys('lcaSubAndQuestNotSubBriefDays')"
                                                                class="add-more ml-0" type="filled">
                                                                <span>+</span> More
                                                            </a>
                                                        </vs-col>
                                                    </vs-row>
                                                </form>
                                            </div>
           
                                            <div class="vx-col w-full">
                                                <h3 class="small-header">Expiry of Passport</h3>
                                                <div class="form_group d-flex align-center w-full ml-4">
                                                        <p class="form_label nowrap mb-0"> Send reminder  to
                                                        </p>
                                                        <multiselect data-vv-as="Send reminder  to"
                                                            v-model="config['reminders']['passportExpiry']['whoWillSendReminder']"
                                                            :allow-empty="true" :options="passportExpiryUserRoles" :multiple="true"
                                                            :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                            placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                                            name="sendReminder" :class="'w-auto multi_list_hide'">
                                                            <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >
                                                        </multiselect>
                                                        <span class="text-danger text-sm" v-show="errors.has('sendReminder')">{{
                                                        errors.first("sendReminder") }}</span>
                                                    </div>
                                                <form @submit.prevent data-vv-scope="passportExpiry">
                                                        <template
                                                            v-for="(item, indexx) in config['reminders']['passportExpiry']['config'] ">
                                                            <div class="vx-col w-full">
                                                                <div class="form_group">
                                                                    <div class="perm_application_delete">
                                                                        <p><vs-input :maxLength="3"
                                                                                @blur="checkBenProfileValue(item, indexx, 'passportExpiry')"
                                                                                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                                class="textfiled" :name="'passportExpiry' + indexx"
                                                                                icon-pack="feather" v-validate="'required'"
                                                                                data-vv-as="Please enter data" icon-after
                                                                                v-model="item.days" /> days prior to the expiry</p>
                                                                        <span v-if="checkProperty(item, 'showError')"
                                                                            class="text-danger text-sm">Days should be less than above entry </span>
                                                                            <span v-if="checkProperty(item, 'showNextError')"
                                                                            class="text-danger text-sm">Days should be greater than below entry </span>
                                                                        <span class="text-danger text-sm"
                                                                            v-if="errors.has('passportExpiry.passportExpiry' + indexx) && !checkProperty(item, 'showError')&& !checkProperty(item, 'showNextError')">
                                                                            Days required </span>
                                                                        <div class="delete"
                                                                            v-if="checkProperty(config['reminders']['passportExpiry'], 'config', 'length') > 1"
                                                                            @click="removefilingfee('passportExpiry', indexx)">
                                                                            <a>
                                                                                <img src="@/assets/images/main/delete-row-img.svg" />
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <vs-row class="more_btn_wrap application_btn"
                                                            v-if="showMoreBtn('passportExpiry')">
                                                            <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                                vs-align="center">
                                                                <a @click="addMoreKeys('passportExpiry')" class="add-more ml-0"
                                                                    type="filled">
                                                                    <span>+</span> More
                                                                </a>
                                                            </vs-col>
                                                        </vs-row>
                                                </form>
                                            </div>
                                            <div class="vx-col w-full">
                                           <h3 class="small-header">Expiry of I-94</h3>
                                           <div class="form_group d-flex align-center w-full ml-4">
                                                <p class="form_label nowrap mb-0"> Send reminder  to
                                                </p>
                                                <multiselect data-vv-as="Send reminder  to"
                                                    v-model="config['reminders']['i94Expiry']['whoWillSendReminder']"
                                                    :allow-empty="true" :options="i94ExpiryUserRoles" :multiple="true"
                                                    :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                    placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                                    name="sendReminder" :class="'w-auto multi_list_hide'">
                                                    <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >
                                                </multiselect>
                                                <span class="text-danger text-sm" v-show="errors.has('sendReminder')">{{
                                                errors.first("sendReminder") }}</span>
                                            </div>
                                           <form @submit.prevent data-vv-scope="i94Expiry">
                                                <template
                                                    v-for="(item, indexx) in config['reminders']['i94Expiry']['config'] ">
                                                    <div class="vx-col w-full">
                                                        <div class="form_group">
                                                            <div class="perm_application_delete">
                                                                <p><vs-input :maxLength="3"
                                                                        @blur="checkBenProfileValue(item, indexx, 'i94Expiry')"
                                                                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                        class="textfiled" :name="'i94Expiry' + indexx"
                                                                        icon-pack="feather" v-validate="'required'"
                                                                        data-vv-as="Please enter data" icon-after
                                                                        v-model="item.days" /> days prior to the expiry</p>
                                                                <span v-if="checkProperty(item, 'showError')"
                                                                    class="text-danger text-sm">Days should be less than above entry </span>
                                                                    <span v-if="checkProperty(item, 'showNextError')"
                                                                    class="text-danger text-sm">Days should be greater than below entry </span>
                                                                <span class="text-danger text-sm"
                                                                    v-if="errors.has('i94Expiry.i94Expiry' + indexx) && !checkProperty(item, 'showError')&& !checkProperty(item, 'showNextError')">
                                                                    Days required </span>
                                                                <div class="delete"
                                                                    v-if="checkProperty(config['reminders']['i94Expiry'], 'config', 'length') > 1"
                                                                    @click="removefilingfee('i94Expiry', indexx)">
                                                                    <a>
                                                                        <img src="@/assets/images/main/delete-row-img.svg" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <vs-row class="more_btn_wrap application_btn"
                                                    v-if="showMoreBtn('i94Expiry')">
                                                    <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                        vs-align="center">
                                                        <a @click="addMoreKeys('i94Expiry')" class="add-more ml-0"
                                                            type="filled">
                                                            <span>+</span> More
                                                        </a>
                                                    </vs-col>
                                                </vs-row>
                                        </form>
                                       </div>
                                       <div class="vx-col w-full">
                                           <h3 class="small-header">Expiry of Work Authorization</h3>
                                           <div class="form_group d-flex align-center w-full ml-4">
                                                <p class="form_label nowrap mb-0"> Send reminder  to
                                                </p>
                                                <multiselect data-vv-as="Send reminder  to"
                                                    v-model="config['reminders']['workAuthorizationExpiry']['whoWillSendReminder']"
                                                    :allow-empty="true" :options="workAuthorizationExpiryUserRoles" :multiple="true"
                                                    :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                    placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                                    name="sendReminder" :class="'w-auto multi_list_hide'">
                                                    <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >
                                                </multiselect>
                                                <span class="text-danger text-sm" v-show="errors.has('sendReminder')">{{
                                                errors.first("sendReminder") }}</span>
                                            </div>
                                           <form @submit.prevent data-vv-scope="workAuthorizationExpiry">
                                                <template
                                                    v-for="(item, indexx) in config['reminders']['workAuthorizationExpiry']['config'] ">
                                                    <div class="vx-col w-full">
                                                        <div class="form_group">
                                                            <div class="perm_application_delete">
                                                                <p><vs-input :maxLength="3"
                                                                        @blur="checkBenProfileValue(item, indexx, 'workAuthorizationExpiry')"
                                                                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                        class="textfiled" :name="'workAuthorizationExpiry' + indexx"
                                                                        icon-pack="feather" v-validate="'required'"
                                                                        data-vv-as="Please enter data" icon-after
                                                                        v-model="item.days" /> days prior to the expiry</p>
                                                                <span v-if="checkProperty(item, 'showError')"
                                                                    class="text-danger text-sm">Days should be less than above entry </span>
                                                                    <span v-if="checkProperty(item, 'showNextError')"
                                                                    class="text-danger text-sm">Days should be greater than below entry </span>
                                                                <span class="text-danger text-sm"
                                                                    v-if="errors.has('workAuthorizationExpiry.workAuthorizationExpiry' + indexx) && !checkProperty(item, 'showError')&& !checkProperty(item, 'showNextError')">
                                                                    Days required </span>
                                                                <div class="delete"
                                                                    v-if="checkProperty(config['reminders']['workAuthorizationExpiry'], 'config', 'length') > 1"
                                                                    @click="removefilingfee('workAuthorizationExpiry', indexx)">
                                                                    <a>
                                                                        <img src="@/assets/images/main/delete-row-img.svg" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <vs-row class="more_btn_wrap application_btn"
                                                    v-if="showMoreBtn('workAuthorizationExpiry')">
                                                    <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                        vs-align="center">
                                                        <a @click="addMoreKeys('workAuthorizationExpiry')" class="add-more ml-0"
                                                            type="filled">
                                                            <span>+</span> More
                                                        </a>
                                                    </vs-col>
                                                </vs-row>
                                            </form>
                                       </div>
                                       <div class="vx-col w-full">
                                           <h3 class="small-header">Duration of Stay</h3>
                                           <div class="form_group d-flex align-center w-full ml-4">
                                                <p class="form_label nowrap mb-0"> Send reminder  to
                                                </p>
                                                <multiselect data-vv-as="Send reminder  to"
                                                    v-model="config['reminders']['totalStayIsNearing6Years']['whoWillSendReminder']"
                                                    :allow-empty="true" :options="lengthOfStayUserRoles" :multiple="true"
                                                    :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                    placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                                    name="sendReminder" :class="'w-auto multi_list_hide'">
                                                    <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >
                                                </multiselect>
                                                <span class="text-danger text-sm" v-show="errors.has('sendReminder')">{{
                                                errors.first("sendReminder") }}</span>
                                            </div>
                                           <form @submit.prevent data-vv-scope="totalStayIsNearing6Years">
                                                <template
                                                    v-for="(item, indexx) in config['reminders']['totalStayIsNearing6Years']['config'] ">
                                                    <div class="vx-col w-full">
                                                        <div class="form_group">
                                                            <div class="perm_application_delete">
                                                                <p><vs-input :maxLength="3"
                                                                        @blur="checkBenProfileValue(item, indexx, 'totalStayIsNearing6Years')"
                                                                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                        class="textfiled" :name="'totalStayIsNearing6Years' + indexx"
                                                                        icon-pack="feather" v-validate="'required'"
                                                                        data-vv-as="Please enter data" icon-after
                                                                        v-model="item.days" /> days to reach the maximum stay in the current visa category</p>
                                                                <span v-if="checkProperty(item, 'showError')"
                                                                    class="text-danger text-sm">Days should be less than above entry </span>
                                                                    <span v-if="checkProperty(item, 'showNextError')"
                                                                    class="text-danger text-sm">Days should be greater than below entry </span>
                                                                <span class="text-danger text-sm"
                                                                    v-if="errors.has('totalStayIsNearing6Years.totalStayIsNearing6Years' + indexx) && !checkProperty(item, 'showError')&& !checkProperty(item, 'showNextError')">
                                                                    Days required </span>
                                                                <div class="delete"
                                                                    v-if="checkProperty(config['reminders']['totalStayIsNearing6Years'], 'config', 'length') > 1"
                                                                    @click="removefilingfee('totalStayIsNearing6Years', indexx)">
                                                                    <a>
                                                                        <img src="@/assets/images/main/delete-row-img.svg" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <vs-row class="more_btn_wrap application_btn"
                                                    v-if="showMoreBtn('totalStayIsNearing6Years')">
                                                    <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                        vs-align="center">
                                                        <a @click="addMoreKeys('totalStayIsNearing6Years')" class="add-more ml-0"
                                                            type="filled">
                                                            <span>+</span> More
                                                        </a>
                                                    </vs-col>
                                                </vs-row>
                                            </form>
                                       </div>
                                       <div class="vx-col w-full config_remainders">
                                        <h3 class="small-header">Global Status</h3>
                                        <form @submit.prevent data-vv-scope="globalStatus">
                                            <div class="global_sec"> 
                                                <template v-if="showGlobal">
                                                    <template v-for="(globalItem, ind) in config['reminders']['globalStatus']">
                                                    
                                                        <div class="gbl_status">
                                                        <div class="form_group d-flex align-center w-full ml-4">
                                                            <p class="form_label nowrap mb-0"> Select Country
                                                            </p>
                                                            <multiselect data-vv-as="Country"
                                                                v-model="config['reminders']['globalStatus'][ind]['countryDetails']"
                                                                @input="config['reminders']['globalStatus'][ind]['countryId'] = config['reminders']['globalStatus'][ind]['countryDetails']['id'];updateCountryList()"
                                                                :allow-empty="true" :options="filteredCountries" :multiple="false" v-validate="'required'"
                                                                :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                                placeholder="Select" label="name" track-by="id" :preselect-first="false"
                                                                :name="'globalStatus'+ind" :class="'w-auto multi_list_hide'">
                                                                <template slot="selection" slot-scope="{ values,  isOpen }">
                                                                    <span class="multiselect__single"
                                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options
                                                                        selected</span>
                                                                </template>
                                                            </multiselect>
                                                            <span class="text-danger text-sm" v-show="errors.has('globalStatus.globalStatus'+ind)">{{
                                                            errors.first('globalStatus.globalStatus'+ind) }}</span>
                                                        </div>
                                                        <template v-for="(item, indexx) in globalItem['config'] ">
                                                            <div class="vx-col w-full">
                                                                <div class="form_group">
                                                                    <div class="perm_application_delete">
                                                                        <p><vs-input :maxLength="3"
                                                                                @blur="checkGlobalValue(item, indexx, ind)"
                                                                                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                                class="textfiled" :name="'globalStatus'+indexx+ind"
                                                                                icon-pack="feather" v-validate="'required'"
                                                                                data-vv-as="Please enter data" icon-after
                                                                                v-model="item.days" /> days prior to the expiry</p>
                                                                        <span v-if="checkProperty(item, 'showError')"
                                                                            class="text-danger text-sm">Days should be less than last entry </span>
                                                                        <span class="text-danger text-sm"
                                                                            v-if="errors.has('globalStatus.globalStatus' + indexx+ind) && !checkProperty(item, 'showError')">
                                                                            Days required </span>
                                                                        <div class="delete" v-if="checkProperty(globalItem, 'config', 'length') > 1"
                                                                    
                                                                        @click="removeStatusConfig(ind, indexx, 'globalStatus')">
                                                                            <a>
                                                                                <img src="@/assets/images/main/delete-row-img.svg" />
                                                                            </a>
                                                                        </div>
                                                                        <!-- v-if="checkProperty(config['reminders']['globalStatus'], 'config', 'length') > 1" -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <vs-row class="more_btn_wrap application_btn" v-if="showMoreGlobalBtn(ind)" >
                                                            <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                                vs-align="center">
                                                                <a @click="addGlobalConfigKeys('globalStatus', ind)" class="add-more ml-0"
                                                                    type="filled">
                                                                    <span>+</span> More
                                                                </a>
                                                            </vs-col>
                                                        </vs-row>
                                                        <div class="delete_complete" v-if="checkProperty(config['reminders']['globalStatus'], 'length') > 1"
                                                            @click="removeStatusConfig(ind)">
                                                            <a>
                                                                <img src="@/assets/images/main/delete-row-img.svg" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                    
                                                    </template>
                                                </template>
                                            </div>
                                            <vs-row class="more_btn_wrap application_btn">
                                                <vs-col class="float-none pr-0 mt-3 padb10 justify-start more_btn add-country_btn" vs-type="flex"
                                                    vs-align="center">
                                                    <a @click="addGlobalConfigKeys()" class="add-more add-country ml-0"
                                                        type="filled">
                                                        <span>+</span>Add Country
                                                    </a>
                                                </vs-col>
                                            </vs-row>
                                        </form>
                                    </div>
                                    </template>
                                    <template v-if="activeTab=='H1BVisa'">
                                        <div class="vx-col w-full">
                                                        <h3 class="small-header">File H1B Petition</h3>
                                                        <div class="form_group d-flex align-center w-full ml-4">
                                                        <p class="form_label nowrap mb-0"> Send reminder  to</p>
                                                        <multiselect data-vv-as="Default Courier"
                                                            v-model="config['reminders']['caseSeleByUscisInLotteryDays']['whoWillSendReminder']"
                                                            :allow-empty="true" :options="uscisH1bReminderList" :multiple="true"
                                                            :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                            placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                                            name="courier" :class="'w-auto multi_list_hide'">
                                                            <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >
                                                        </multiselect>
                                                        <span class="text-danger text-sm" v-show="errors.has('courier')">{{
                                                            errors.first("courier") }}</span>
                                                        </div>
                                                        <form @submit.prevent data-vv-scope="caseSeleByUscisInLotteryDays">

                                                                <template
                                                                    v-for="(item, indexx) in config['reminders']['caseSeleByUscisInLotteryDays']['config'] ">

                                                                    <div class="vx-col w-full">

                                                                        <div class="form_group">

                                                                            <div class="perm_application_delete">

                                                                                <p><vs-input :maxLength="3"
                                                                                        @blur="checkInputI140Value(item, indexx, 'caseSeleByUscisInLotteryDays')"
                                                                                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                                        class="textfiled"
                                                                                        :name="'caseSeleByUscisInLotteryDays' + indexx"
                                                                                        icon-pack="feather" v-validate="'required'"
                                                                                        data-vv-as="Please enter data" icon-after
                                                                                        v-model="item.days" /> days after case is selected
                                                                                    by USCIS in lottery </p>

                                                                                <span v-if="checkProperty(item, 'showError')"
                                                                                    class="text-danger text-sm">Days should be greater than
                                                                                    last entry </span>

                                                                                <span class="text-danger text-sm"
                                                                                    v-show="errors.has('caseSeleByUscisInLotteryDays.caseSeleByUscisInLotteryDays' + indexx) && !checkProperty(item, 'showError')">
                                                                                    Days required </span>

                                                                                <div class="delete"
                                                                                    v-if="checkProperty(config['reminders']['caseSeleByUscisInLotteryDays'], 'config', 'length') > 1"
                                                                                    @click="removefilingfee('caseSeleByUscisInLotteryDays', indexx)">

                                                                                    <a>

                                                                                        <img
                                                                                            src="@/assets/images/main/delete-row-img.svg" />

                                                                                    </a>

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </template>

                                                                <vs-row class="more_btn_wrap application_btn"
                                                                    v-if="showMoreBtn('caseSeleByUscisInLotteryDays')">

                                                                    <vs-col class="float-none pr-0 padb10 justify-start more_btn"
                                                                        vs-type="flex" vs-align="center">

                                                                        <a @click="addMoreKeys('caseSeleByUscisInLotteryDays')"
                                                                            class="add-more ml-0" type="filled">

                                                                            <span>+</span> More

                                                                        </a>

                                                                    </vs-col>

                                                            </vs-row>

                                                        </form>  
                                                    </div>
                                                    <div class="vx-col w-full">
                                           <h3 class="small-header">Visa Expiration</h3>
                                           <div class="form_group d-flex align-center w-full ml-4">
                                                <p class="form_label nowrap mb-0"> Send reminder  to
                                                </p>
                                                <multiselect data-vv-as="Send reminder  to"
                                                    v-model="config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder']"
                                                    :allow-empty="true" :options="visaExpiryUserRoles" :multiple="true"
                                                    :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                    placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                                    name="sendReminder" :class="'w-auto multi_list_hide'">
                                                    <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >
                                                </multiselect>
                                                <span class="text-danger text-sm" v-show="errors.has('sendReminder')">{{
                                                errors.first("sendReminder") }}</span>
                                            </div>
                                           <form @submit.prevent data-vv-scope="priorToExpiryDaysH1b">
                                                <template
                                                    v-for="(item, indexx) in config['reminders']['priorToExpiryDaysH1b']['config'] ">
                                                    <div class="vx-col w-full">
                                                        <div class="form_group">
                                                            <div class="perm_application_delete">
                                                                <p><vs-input :maxLength="3"
                                                                        @blur="checkBenProfileValue(item, indexx, 'priorToExpiryDaysH1b')"
                                                                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                        class="textfiled" :name="'priorToExpiryDaysH1b' + indexx"
                                                                        icon-pack="feather" v-validate="'required'"
                                                                        data-vv-as="Please enter data" icon-after
                                                                        v-model="item.days" /> days prior to the expiry</p>
                                                                <span v-if="checkProperty(item, 'showError')"
                                                                    class="text-danger text-sm">Days should be less than above entry </span>
                                                                    <span v-if="checkProperty(item, 'showNextError')"
                                                                    class="text-danger text-sm">Days should be greater than below entry </span>
                                                                <span class="text-danger text-sm"
                                                                    v-if="errors.has('priorToExpiryDaysH1b.priorToExpiryDaysH1b' + indexx) && !checkProperty(item, 'showError')&& !checkProperty(item, 'showNextError')">
                                                                    Days required </span>
                                                                <div class="delete"
                                                                    v-if="checkProperty(config['reminders']['priorToExpiryDaysH1b'], 'config', 'length') > 1"
                                                                    @click="removefilingfee('priorToExpiryDaysH1b', indexx)">
                                                                    <a>
                                                                        <img src="@/assets/images/main/delete-row-img.svg" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <vs-row class="more_btn_wrap application_btn"
                                                    v-if="showMoreBtn('priorToExpiryDaysH1b')">
                                                    <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                        vs-align="center">
                                                        <a @click="addMoreKeys('priorToExpiryDaysH1b')" class="add-more ml-0"
                                                            type="filled">
                                                            <span>+</span> More
                                                        </a>
                                                    </vs-col>
                                                </vs-row>
                                        </form>
                                       </div>
                                    </template>
                                    <template v-if="activeTab=='PERM'">
                                        <div class="vx-col w-full">
                                        <h3 class="small-header">Release of Advertisements
                                        </h3>
                                        <form @submit.prevent data-vv-scope="pwdCertOrBeforeExpiryDays">

                                        <template
                                            v-for="(item, indexx) in config['reminders']['pwdCertOrBeforeExpiryDays']['config'] ">

                                            <div class="vx-col w-full">

                                                <div class="form_group">

                                                    <div class="perm_application_delete">

                                                        <p><vs-input :maxLength="3"
                                                                @blur="checkInputI140Value(item, indexx, 'pwdCertOrBeforeExpiryDays')"
                                                                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                class="textfiled"
                                                                :name="'pwdCertOrBeforeExpiryDays' + indexx"
                                                                icon-pack="feather" v-validate="'required'"
                                                                data-vv-as="Please enter data" icon-after
                                                                v-model="item.days" /> days after PWD is
                                                            certified/before expiry of PWD</p>

                                                        <span v-if="checkProperty(item, 'showError')"
                                                            class="text-danger text-sm">Days should be greater than last
                                                            entry </span>

                                                        <span class="text-danger text-sm"
                                                            v-show="errors.has('pwdCertOrBeforeExpiryDays.pwdCertOrBeforeExpiryDays' + indexx) && !checkProperty(item, 'showError')">
                                                            Days required </span>

                                                        <div class="delete"
                                                            v-if="checkProperty(config['reminders']['pwdCertOrBeforeExpiryDays'], 'config', 'length') > 1"
                                                            @click="removefilingfee('pwdCertOrBeforeExpiryDays', indexx)">

                                                            <a>

                                                                <img src="@/assets/images/main/delete-row-img.svg" />

                                                            </a>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </template>

                                        <vs-row class="more_btn_wrap application_btn"
                                            v-if="showMoreBtn('pwdCertOrBeforeExpiryDays')">

                                            <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                vs-align="center">

                                                <a @click="addMoreKeys('pwdCertOrBeforeExpiryDays')"
                                                    class="add-more ml-0" type="filled">

                                                    <span>+</span> More

                                                </a>

                                            </vs-col>

                                        </vs-row>

                                        </form>
                                        </div>
                                        <div class="vx-col w-full">
                                        <h3 class="small-header">Filing of PERM
                                        </h3>
                                        <form @submit.prevent data-vv-scope="lastAdvReleaseBriefDays">
                                        <template
                                            v-for="(item, indexx) in config['reminders']['lastAdvReleaseBriefDays']['config'] ">



                                            <div class="vx-col w-full">

                                                <div class="form_group">

                                                    <div class="perm_application_delete">



                                                        <p><vs-input  :maxLength="3"
                                                                v-on:keyup="checkCoolingInputValue(item, indexx)"
                                                                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                class="textfiled"
                                                                :name="'lastAdvReleaseBriefDays' + indexx"
                                                                icon-pack="feather" v-validate="'required|'+'maxval:179'"
                                                                data-vv-as="Please enter data" icon-after
                                                                v-model="item.days" /> days after the cooling period (30
                                                            days) of last Advertisement is released and within 180 days
                                                            from the first advertisement is released</p>

                                                        <span v-if="checkProperty(item, 'showError')"
                                                            class="text-danger text-sm">Days should be less than last
                                                            entry </span>

                                                        <span class="text-danger text-sm"
                                                            v-show="errors.has('lastAdvReleaseBriefDays.lastAdvReleaseBriefDays' + indexx) && !checkProperty(item, 'showError')">
                                                            {{ errors.first('lastAdvReleaseBriefDays.lastAdvReleaseBriefDays' + indexx) }} </span>

                                                        <div class="delete"
                                                            v-if="checkProperty(config['reminders']['lastAdvReleaseBriefDays'], 'config', 'length') > 1"
                                                            @click="removefilingfee('lastAdvReleaseBriefDays', indexx)">

                                                            <a>

                                                                <img src="@/assets/images/main/delete-row-img.svg" />

                                                            </a>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </template>

                                        <vs-row class="more_btn_wrap w-0 application_btn"
                                            v-if="showMoreBtn('lastAdvReleaseBriefDays')">

                                            <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                vs-align="center">

                                                <a @click="addMoreKeys('lastAdvReleaseBriefDays')" class="add-more ml-0"
                                                    type="filled">

                                                    <span>+</span> More

                                                </a>

                                            </vs-col>

                                        </vs-row>



                                        </form>
                                        </div>
                                        
                                        <div class="vx-col w-full">
                                            <h3 class="small-header">Sponsorship Questionnaire by Petitioner</h3>
                                            <div class="form_group d-flex align-center w-full ml-4">
                                                        <p class="form_label nowrap mb-0"> Send reminder  to</p>
                                                        <multiselect data-vv-as="Default Courier"
                                                            v-model="config['reminders']['sponQuestionnire']['whoWillSendReminder']"
                                                            :allow-empty="true" :options="sponsorUserRolesList" :multiple="true"
                                                            :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                            placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                                            name="courier" :class="'w-auto multi_list_hide'">
                                                            <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >
                                                        </multiselect>
                                                        <span class="text-danger text-sm" v-show="errors.has('courier')">{{
                                                            errors.first("courier") }}</span>
                                                        </div>
                                        </div>
                                        <div class="vx-col w-full">
                                            <form @submit.prevent data-vv-scope="sponQuestionnire">
                                            <template
                                                v-for="(item, indexx) in config['reminders']['sponQuestionnire']['config'] ">
                                                <div class="vx-col w-full">
                                                    <div class="form_group">
                                                        <div class="perm_application_delete">
                                                            <p>If not submitted with<vs-input :maxLength="3"
                                                                    @blur="checkInputI140Value(item, indexx, 'sponQuestionnire')"
                                                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                    class="textfiled" :name="'sponQuestionnire' + indexx"
                                                                    icon-pack="feather" v-validate="'required'"
                                                                    data-vv-as="Please enter data" icon-after
                                                                    v-model="item.days" />days from PERM Filed Date</p>

                                                            <span v-if="checkProperty(item, 'showError')"
                                                                class="text-danger text-sm">Days should be greater than last
                                                                entry </span>

                                                            <span class="text-danger text-sm"
                                                                v-if="errors.has('sponQuestionnire.sponQuestionnire' + indexx) && !checkProperty(item, 'showError')">
                                                                Days required </span>

                                                            <div class="delete"
                                                                v-if="checkProperty(config['reminders']['sponQuestionnire'], 'config', 'length') > 1"
                                                                @click="removefilingfee('sponQuestionnire', indexx)">

                                                                <a>

                                                                    <img src="@/assets/images/main/delete-row-img.svg" />

                                                                </a>

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </template>

                                            <vs-row class="more_btn_wrap application_btn"
                                                v-if="showMoreBtn('sponQuestionnire')">

                                                <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                    vs-align="center">

                                                    <a @click="addMoreKeys('sponQuestionnire')" class="add-more ml-0"
                                                        type="filled">

                                                        <span>+</span> More

                                                    </a>

                                                </vs-col>

                                            </vs-row>

                                        </form>
                                        </div>
                                       
                                    </template>
                                    <template v-if="activeTab=='I140ImmigrantPetition'">
                                        
                                        <div class="vx-col w-full">
                                                <h3 class="small-header">Filing of I-140
                                                </h3>
                                                <div class="form_group d-flex align-center w-full ml-4">

                                                <p class="form_label nowrap mb-0"> Send reminder  to
                                                </p>

                                                <multiselect data-vv-as="Default Courier"
                                                    v-model="config['reminders']['priorToExpiryPermDays']['whoWillSendReminder']"
                                                    :allow-empty="true" :options="gcfamilyflowN400ReminderList" :multiple="true"
                                                    :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                    placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                                    name="courier" :class="'w-auto multi_list_hide'">

                                                    <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >

                                                </multiselect>

                                                <span class="text-danger text-sm" v-show="errors.has('courier')">{{
                                                    errors.first("courier") }}</span>

                                                </div>
                                                <form @submit.prevent data-vv-scope="priorToExpiryPermDays">

                                                <template
                                                    v-for="(item, indexx) in config['reminders']['priorToExpiryPermDays']['config'] ">



                                                    <div class="vx-col w-full">

                                                        <div class="form_group">

                                                            <div class="perm_application_delete">



                                                                <p><vs-input  :maxLength="3"
                                                                        v-on:keyup="checkPermInputValue(item, indexx)"
                                                                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                        class="textfiled"
                                                                        :name="'priorToExpiryPermDays' + indexx"
                                                                        icon-pack="feather" v-validate="'required|'+'maxval:179'"
                                                                        data-vv-as="Please enter data" icon-after
                                                                        v-model="item.days" /> {{ 'days prior to the expiry of PERM(<180 days after PERM Certified)' }}</p>

                                                                        <span v-if="checkProperty(item, 'showError')"
                                                                            class="text-danger text-sm">Days should be less than
                                                                            last entry </span>

                                                                        <span class="text-danger text-sm"
                                                                            v-show="errors.has('priorToExpiryPermDays.priorToExpiryPermDays' + indexx) && !checkProperty(item, 'showError')">
                                                                            {{ errors.first('priorToExpiryPermDays.priorToExpiryPermDays' + indexx) }} </span>
                                                                            <!-- Days required -->
                                                                        <div class="delete"
                                                                            v-if="checkProperty(config['reminders']['priorToExpiryPermDays'], 'config', 'length') > 1"
                                                                            @click="removefilingfee('priorToExpiryPermDays', indexx)">

                                                                            <a>

                                                                                <img
                                                                                    src="@/assets/images/main/delete-row-img.svg" />

                                                                            </a>

                                                                        </div>

                                                            </div>

                                                        </div>

                                                    </div>

                                                </template>

                                                <vs-row class="more_btn_wrap w-0 application_btn"
                                                    v-if="showMoreBtn('priorToExpiryPermDays')">

                                                    <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                        vs-align="center">

                                                        <a @click="addMoreKeys('priorToExpiryPermDays')" class="add-more ml-0"
                                                            type="filled">

                                                            <span>+</span> More

                                                        </a>

                                                    </vs-col>

                                                </vs-row>



                                                </form>
                                                </div>
                                    
                                    </template>
                                    <template v-if="activeTab=='I485Employment'">
                                        <div class="vx-col w-full">
                                        <h3 class="small-header">Filing of I-485
                                        </h3>
                                        <div class="form_group d-flex align-center w-full ml-4">

                                        <p class="form_label nowrap mb-0"> Send reminder  to
                                        </p>

                                        <multiselect data-vv-as="Default Courier"
                                            v-model="config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder']"
                                            :allow-empty="true" :options="permH1bReminderList" :multiple="true"
                                            :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                            placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                            name="courier" :class="'w-auto multi_list_hide'">

                                            <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >

                                        </multiselect>

                                        <span class="text-danger text-sm" v-show="errors.has('courier')">{{
                                            errors.first("courier") }}</span>

                                        </div>
                                        <form @submit.prevent data-vv-scope="i140ApprovedDuringDays">

                                        <template
                                            v-for="(item, indexx) in config['reminders']['i140ApprovedDuringDays']['config'] ">

                                            <div class="vx-col w-full">

                                                <div class="form_group">

                                                    <div class="perm_application_delete">

                                                        <p>I-140 approved and<vs-input :maxLength="3"
                                                                @blur="checkInputI140Value(item, indexx, 'i140ApprovedDuringDays')"
                                                                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                class="textfiled"
                                                                :name="'i140ApprovedDuringDays' + indexx"
                                                                icon-pack="feather" v-validate="'required'"
                                                                data-vv-as="Please enter data" icon-after
                                                                v-model="item.days" /> days after the Priority Date is
                                                            current</p>

                                                        <span v-if="checkProperty(item, 'showError')"
                                                            class="text-danger text-sm">Days should be greater than last
                                                            entry </span>

                                                        <span class="text-danger text-sm"
                                                            v-show="errors.has('i140ApprovedDuringDays.i140ApprovedDuringDays' + indexx) && !checkProperty(item, 'showError')">
                                                            Days required </span>

                                                        <div class="delete"
                                                            v-if="checkProperty(config['reminders']['i140ApprovedDuringDays'], 'config', 'length') > 1"
                                                            @click="removefilingfee('i140ApprovedDuringDays', indexx)">

                                                            <a>

                                                                <img src="@/assets/images/main/delete-row-img.svg" />

                                                            </a>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </template>

                                        <vs-row class="more_btn_wrap application_btn"
                                            v-if="showMoreBtn('i140ApprovedDuringDays')">

                                            <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                vs-align="center">

                                                <a @click="addMoreKeys('i140ApprovedDuringDays')" class="add-more ml-0"
                                                    type="filled">

                                                    <span>+</span> More

                                                </a>

                                            </vs-col>

                                        </vs-row>

                                        </form>
                                        </div>
                                    </template>
                                    <template v-if="activeTab=='N400Application'">
                                        
                                        <div class="vx-col w-full">
                                        <h3 class="small-header">Filing of N-400
                                        </h3>
                                        <div class="form_group d-flex align-center w-full ml-4">

                                        <p class="form_label nowrap mb-0"> Send reminder  to
                                        </p>

                                        <multiselect data-vv-as="Default Courier"
                                            v-model="config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder']"
                                            :allow-empty="true" :options="gcEmploymentI485ReminderList" :multiple="true"
                                            :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                            placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                            name="courier" :class="'w-auto multi_list_hide'">

                                            <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >

                                        </multiselect>

                                        <span class="text-danger text-sm" v-show="errors.has('courier')">{{
                                            errors.first("courier") }}</span>

                                        </div>
                                                                                <form @submit.prevent data-vv-scope="gcEmpi485ApprovedDays">

                                                                                    <template
                                                                                        v-for="(item, indexx) in config['reminders']['gcEmpi485ApprovedDays']['config'] ">

                                                                                        <div class="vx-col w-full">

                                                                                            <div class="form_group">

                                                                                                <div class="perm_application_delete">

                                                                                                    <p><vs-input :maxLength="3"
                                                                                                            @blur="checkInputI140Value(item, indexx, 'gcEmpi485ApprovedDays')"
                                                                                                            oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                                                            class="textfiled"
                                                                                                            :name="'gcEmpi485ApprovedDays' + indexx"
                                                                                                            icon-pack="feather" v-validate="'required'"
                                                                                                            data-vv-as="Please enter data" icon-after
                                                                                                            v-model="item.days" /> days after I-485 is approved</p>

                                                                                                    <span v-if="checkProperty(item, 'showError')"
                                                                                                        class="text-danger text-sm">Days should be greater than last
                                                                                                        entry </span>

                                                                                                    <span class="text-danger text-sm"
                                                                                                        v-show="errors.has('gcEmpi485ApprovedDays.gcEmpi485ApprovedDays' + indexx) && !checkProperty(item, 'showError')">
                                                                                                        Days required </span>

                                                                                                    <div class="delete"
                                                                                                        v-if="checkProperty(config['reminders']['gcEmpi485ApprovedDays'], 'config', 'length') > 1"
                                                                                                        @click="removefilingfee('gcEmpi485ApprovedDays', indexx)">

                                                                                                        <a>

                                                                                                            <img src="@/assets/images/main/delete-row-img.svg" />

                                                                                                        </a>

                                                                                                    </div>

                                                                                                </div>

                                                                                            </div>

                                                                                        </div>

                                                                                    </template>

                                                                                    <vs-row class="more_btn_wrap application_btn"
                                                                                        v-if="showMoreBtn('gcEmpi485ApprovedDays')">

                                                                                        <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                                                            vs-align="center">

                                                                                            <a @click="addMoreKeys('gcEmpi485ApprovedDays')" class="add-more ml-0"
                                                                                                type="filled">

                                                                                                <span>+</span> More

                                                                                            </a>

                                                                                        </vs-col>

                                                                                    </vs-row>

                                                                                </form>
                                        </div>
                                    
                                    </template>
                                    <template v-if="activeTab=='I485Family'">
                                        
                                        <div class="vx-col w-full">
                                        <h3 class="small-header">Filing of I-485
                                        </h3>
                                        <div class="form_group d-flex align-center w-full ml-4">

                                        <p class="form_label nowrap mb-0"> Send reminder  to
                                        </p>

                                        <multiselect data-vv-as="Default Courier"
                                            v-model="config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder']"
                                            :allow-empty="true" :options="gcEmploymentN400ReminderList" :multiple="true"
                                            :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                            placeholder="Select" label="roleName" track-by="roleName" :preselect-first="false"
                                            name="courier" :class="'w-auto multi_list_hide'">

                                            <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >

                                        </multiselect>

                                        <span class="text-danger text-sm" v-show="errors.has('courier')">{{
                                            errors.first("courier") }}</span>

                                        </div>
                                        <form @submit.prevent data-vv-scope="i130ApprovedDuringDays">

                                            <template
                                                v-for="(item, indexx) in config['reminders']['i130ApprovedDuringDays']['config'] ">

                                                <div class="vx-col w-full">

                                                    <div class="form_group">

                                                        <div class="perm_application_delete">

                                                            <p>I-130 Approved and<vs-input :maxLength="3"
                                                                    @blur="checkInputI140Value(item, indexx, 'i130ApprovedDuringDays')"
                                                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                    class="textfiled"
                                                                    :name="'i140ApprovedDuringDays' + indexx"
                                                                    icon-pack="feather" v-validate="'required'"
                                                                    data-vv-as="Please enter data" icon-after
                                                                    v-model="item.days" /> days after the Priority Date is
                                                                current</p>

                                                            <span v-if="checkProperty(item, 'showError')"
                                                                class="text-danger text-sm">Days should be greater than last
                                                                entry </span>

                                                            <span class="text-danger text-sm"
                                                                v-show="errors.has('i130ApprovedDuringDays.i130ApprovedDuringDays' + indexx) && !checkProperty(item, 'showError')">
                                                                Days required </span>

                                                            <div class="delete"
                                                                v-if="checkProperty(config['reminders']['i130ApprovedDuringDays'], 'config', 'length') > 1"
                                                                @click="removefilingfee('i130ApprovedDuringDays', indexx)">

                                                                <a>

                                                                    <img src="@/assets/images/main/delete-row-img.svg" />

                                                                </a>

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </template>

                                            <vs-row class="more_btn_wrap application_btn"
                                                v-if="showMoreBtn('i130ApprovedDuringDays')">

                                                <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                    vs-align="center">

                                                    <a @click="addMoreKeys('i130ApprovedDuringDays')" class="add-more ml-0"
                                                        type="filled">

                                                        <span>+</span> More

                                                    </a>

                                                </vs-col>

                                            </vs-row>

                                        </form>
                                        </div>
                                    </template>
                                    <template v-if="activeTab=='L1Visa'">
                                        <div class="vx-col w-full">
                                            <h3 class="small-header">Visa Expiration
                                            </h3>
                                            
                                            <div class="form_group d-flex align-center w-full ml-4">

                                                <p class="form_label nowrap mb-0"> Send
                                                    reminder  to</p>

                                                <multiselect data-vv-as="Default Courier"
                                                    v-model="config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder']"
                                                    :allow-empty="true" :options="renewalH1bReminderList" :multiple="true" 
                                                    :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                    placeholder="Select" label="roleName" track-by="roleName"
                                                    :preselect-first="false" name="courier"
                                                    :class="'w-auto multi_list_hide'">

                                                    <template
                                                                slot="selection"
                                                                slot-scope="{ values, remove  }"
                                                            >
                                                                <span class="multiselect__tags_default" v-if="values.length">
                                                                <div class="multiselect__tags-wrap">
                                                                    <span class="multiselect__tag">
                                                                        <span class="role_name">
                                                                        {{ values[0].roleName }}
                                                                    </span>
                                                                    <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                                    </span>
                                                                </div>
                                                                
                                                            <strong v-if="values.length > 1"  class="multiselect__strong">
                                                                    + {{ values.length-1 }}
                                                                </strong>
                                                                </span></template
                                                            >

                                                </multiselect>

                                                <span class="text-danger text-sm" v-show="errors.has('courier')">{{
                                                    errors.first("courier") }}</span>

                                            </div>
                                            <form @submit.prevent data-vv-scope="priorToExpiryDaysH1b">

                                            <template
                                                v-for="(item, indexx) in config['reminders']['priorToExpiryDaysH1b']['config'] ">

                                                <div class="vx-col w-full">

                                                    <div class="form_group">

                                                        <div class="perm_application_delete">

                                                            <p><vs-input :maxLength="3"
                                                                    @blur="checkH1bInputValue(item, indexx)"
                                                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                    class="textfiled"
                                                                    :name="'priorToExpiryDaysH1b' + indexx"
                                                                    icon-pack="feather" v-validate="'required'"
                                                                    data-vv-as="Please enter data" icon-after
                                                                    v-model="item.days" /> days prior to the H-1B expiry
                                                            </p>

                                                            <span v-if="checkProperty(item, 'showError')"
                                                                class="text-danger text-sm">Days should be less than last
                                                                entry </span>

                                                            <span class="text-danger text-sm"
                                                                v-show="errors.has('priorToExpiryDaysH1b.priorToExpiryDaysH1b' + indexx) && !checkProperty(item, 'showError')">
                                                                Days required </span>

                                                            <div class="delete"
                                                                v-if="checkProperty(config['reminders']['priorToExpiryDaysH1b'], 'config', 'length') > 1"
                                                                @click="removefilingfee('priorToExpiryDaysH1b', indexx)">

                                                                <a>

                                                                    <img src="@/assets/images/main/delete-row-img.svg" />

                                                                </a>

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </template>

                                            <vs-row class="more_btn_wrap application_btn"
                                                v-if="showMoreBtn('priorToExpiryDaysH1b')">

                                                <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex"
                                                    vs-align="center">

                                                    <a @click="addMoreKeys('priorToExpiryDaysH1b')" class="add-more ml-0"
                                                        type="filled">

                                                        <span>+</span> More

                                                    </a>

                                                </vs-col>

                                            </vs-row>

                                            </form>
                                           
                                            </div>
                                    </template>
                                    <template v-if="activeTab=='Others'">
                                        <div class="vx-col w-full" v-if="showInvoice">
                                            <h3 class="small-header">Issue Invoice</h3>
                                            <div class="form_group d-flex align-center w-full ml-4">
                                                <p class="form_label nowrap mb-0"> Send  reminder  to</p>
                                                <multiselect data-vv-as="Default Courier"
                                                    v-model="config['reminders']['invoicePaymentReminder']['whoWillSendReminder']"
                                                    :allow-empty="true" :options="invoiceReminderList" :multiple="true"  :hideSelected="true"
                                                    :close-on-select="false" :clear-on-select="true" :preserve-search="true"
                                                    placeholder="Select" label="roleName" track-by="roleName"
                                                    :preselect-first="true" name="courier"
                                                    :class="'w-auto multi_list_hide'">
                                                    <template slot="selection" slot-scope="{ values, remove }" >
                                                        <span class="multiselect__tags_default" v-if="values.length">
                                                        <div class="multiselect__tags-wrap">
                                                            <span class="multiselect__tag">
                                                                <span class="role_name">
                                                                {{ values[0].roleName }}
                                                            </span>
                                                            <i  @click="remove(values[0])" tabindex="1" class="multiselect__tag-icon"></i>
                                                            </span>
                                                        </div>
                                                    <strong v-if="values.length > 1"  class="multiselect__strong">
                                                            + {{ values.length-1 }}
                                                        </strong>
                                                        </span>
                                                    </template>
                                                </multiselect>
                                                <span class="text-danger text-sm" v-show="errors.has('courier')">{{errors.first("courier") }}</span>
                                            </div>
                                            <form @submit.prevent data-vv-scope="invoicePaymentReminder">
                                                <template v-for="(item, indexx) in config['reminders']['invoicePaymentReminder']['config'] ">
                                                    <div class="vx-col w-full">
                                                        <div class="form_group">
                                                            <div class="perm_application_delete">
                                                                <p><vs-input :maxLength="3"
                                                                    @blur="checkInvoiceValue(item, indexx)"
                                                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                                                                    class="textfiled"
                                                                    @input="updateVal"
                                                                    :key="'invoicePaymentReminder' + indexx"
                                                                    :name="'invoicePaymentReminder' + indexx"
                                                                    icon-pack="feather" v-validate="'required'"
                                                                    data-vv-as="Please enter data" icon-after
                                                                    v-model="item.days" /> days prior to the Invoice raised
                                                                </p>
                                                                <span v-if="checkProperty(item, 'showError')"
                                                                    class="text-danger text-sm">Days should be less than last
                                                                    entry </span>
                                                                <span class="text-danger text-sm"
                                                                    v-show="errors.has('invoicePaymentReminder.invoicePaymentReminder' + indexx) && !checkProperty(item, 'showError')">
                                                                    Days required </span>
                                                                <div class="delete"
                                                                    v-if="checkProperty(config['reminders']['invoicePaymentReminder'], 'config', 'length') > 1"
                                                                    @click="removefilingfee('invoicePaymentReminder', indexx)">
                                                                    <a>
                                                                        <img src="@/assets/images/main/delete-row-img.svg" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <vs-row class="more_btn_wrap application_btn" v-if="showMoreBtn('invoicePaymentReminder')">
                                                    <vs-col class="float-none pr-0 padb10 justify-start more_btn" vs-type="flex" vs-align="center">
                                                        <a @click="addMoreKeys('invoicePaymentReminder')" class="add-more ml-0"
                                                            type="filled"> <span>+</span> More  </a>
                                                    </vs-col>
                                                </vs-row>
                                            </form>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
















            

                <div class="vx-col w-100">
                    <div class="popup-footer form-footer form-footer2 height-auto mb-4">
                        <vs-button color="success" class="save" :disabled="configSaving"
                            @click="updateQconfig" type="filled">
                            <template v-if="checkProperty(this.configDetails, '_id')">Update</template>
                            <template v-else>Save</template>
                        </vs-button>
                    </div>
                </div>
        </div>
                        





        <!-- <div class="popup-footer form-footer"> 

     

        <vs-button color="success" class="save" :disabled="configSaving" @click="updateQconfig" type="filled"> 

         <template v-if="checkProperty(this.configDetails ,'_id'  )">Update</template> 

         <template v-else>Save</template> 

         

        </vs-button> 

    </div> -->

    </form>
</template> 

  

<script>

import DateRangePicker from "vue2-daterange-picker";

import Paginate from "vuejs-paginate";

import Datepicker from "vuejs-datepicker-inv";

import Multiselect from "vue-multiselect-inv";

import JQuery from "jquery";

import selectField from "@/views/forms/fields/simpleselect.vue";

import datepickerField from "@/views/forms/fields/datepicker.vue";

import immiInput from "@/views/forms/fields/simpleinput.vue";

import moment from "moment"

import _ from "lodash";

import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {

    provide() {

        return {

            parentValidator: this.$validator,

        };

    },

    props: {

        branchId: {

            type: String,

            default: ''

        }

    },

    components: {

        immiInput,

        datepickerField,

        selectField,

        Datepicker,

        DateRangePicker,

        Multiselect,

        Paginate,

    },

    data: () => ({
        showInvoice:true,
        activeTab:'BeneficiaryProfile',
        reminderTabs:[
                {
                    'name':'Beneficiary or Applicant Actions',
                    'id':1,
                    'selectedTab':'BeneficiaryProfile'
                },
                {
                    'name':'H1B Visa',
                    'id':2,
                    'selectedTab':'H1BVisa'
                },
                {
                    'name':'PERM',
                    'id':3,
                    'selectedTab':'PERM'
                },
                {
                    'name':'I-140 - Immigrant Petition',
                    'id':4,
                    'selectedTab':'I140ImmigrantPetition'
                },
                {
                    'name':'I-485 - Adjustment of Status (Employment)',
                    'id':5,
                    'selectedTab':'I485Employment'
                },
                {
                    'name':'N-400 - Application for Naturalization',
                    'id':6,
                    'selectedTab':'N400Application'
                },
                {
                    'name':'I-485 - Adjustment of Status (Family)',
                    'id':7,
                    'selectedTab':'I485Family'
                },
                {
                    'name':'L1 Visa',
                    'id':8,
                    'selectedTab':'L1Visa'
                },
                {
                    'name':'Others',
                    'id':9,
                    'selectedTab':'Others'
                },
        ],
        showGlobal:true,
        countries:[],
        filteredCountries:[],
        pwdExpiryUserRoles:[],
        visaExpiryUserRoles:[],
        workAuthorizationExpiryUserRoles:[],
        lengthOfStayUserRoles:[],
        passportExpiryUserRoles:[],
        i94ExpiryUserRoles:[],
        showAddseasonsPopup: false,
        seletedObj: {
            effectiveDate: null,
            seasonYear: null,
        },
        seasonsYears: [],
        capSeasonEffectiveList: [],
        allSesasonsList: [],
        allUserRoles: [],
        masterCourierList: [],
        configSaving: false,
        contatctInfoList: [

            { id: 'law_firm', 'name': 'Law Firm' },

            { id: 'attorney', 'name': 'Attorney' }

        ],

        config: {
            mfaRequired:false,
            currentSeasonYear: '',

            manageCapRegistrations: false,

            remindPtnrInfoUpdateDays: null,

            'ptnrBriefDays': null,

            benfSubQuestBriefDays: null,

            allowCustonCaseNo: false,
            showCaseDeadLineDateforPetitioner:false,

            "prefillCountryInQuestionnaire": false,

            //   "isI94DSExpiryDate":false, 

            "usePtnrAddrAsMailingAddrInUSCISForms": false,

            acceptCompayDocsForPtnr: false,

            isAllowExternalCases: false,

            requiredPinForQuesSubmit: false,

            petiApprovReqPWDDoc: false,

            procefilPERMCoolNotMet: false,

            "isPtnrActAsUSCISFormsPreparer": false,

            allowToAddLCALayers: false,

            "addressEntityIOrHomeForLCA": false, // Send for Entity/Home Address 

            "multipleJobDutiesForLCA": false,

            "multiEduDetailsForLCA": false, // Send for multiple education details 

            "defaultCourierIds": null,

            defaultCourierDetails: [],

            "filingFeeCategoryType": 'manual_entry',  //false =="manual_entry" , true="pre_defined" 

            "ptnrAttorneySignByInternal": false,

            "preSOCCodeMandatoryLCA": false,

            yearsOfExpRequiredForLCA: false,

            taskApprovalRequired: false,

            commuEmails: '',

            "caseDeadlineDays": null,

            rfeCaseDeadlineDays: null,

            "priorI94DeadlineDays": null,

            advCoolingPeriod: 30,

            advMinDuration: 30,

            priorFormsEffectiveDays: null,

            tenantDefaultTZ: "",

            requiredQBForInvoice: false,

            permFileDaysAfterLastAdv: null,

            handlePwdActivityUsers: [],

            whoWillReassignCase: [],

            contactInfoOfG28Form: null,

            // 'caseSeleByUscisInLotteryDays': null, 

            // 'priorToExpiryDaysH1b': null, 

            // 'lcaSubAndQuestNotSubBriefDays': null, 

            // 'pwdCertOrBeforeExpiryDays': null, 

            // 'lastAdvReleaseBriefDays': null, 

            // 'priorToExpiryPermDays': null, 

            // 'i140ApprovedDuringDays': null, 

            // 'gcEmpi485ApprovedDays': null, 

            // 'i130ApprovedDuringDays': null, 

            // 'gcfamilyi485ApprovedDays': null, 

            // 'priorToExpiryl1aOrl1b': null, 

            // 'l1i140ApprovedDuringDays': null, 

            reminders: {

                pwdExpiry: {
                    whoWillSendReminder: [],
                    config: [

                        {

                            days: ''

                        },

                    ]

                },

                i140: {

                    config: [

                        {

                            days: ''

                        },

                    ]

                },

                sponQuestionnire: {
                    whoWillSendReminder: [],
                    config: [
                        {
                            days: ''
                        },
                    ]
                },
                passportExpiry: {
                    whoWillSendReminder: [],
                    config: [
                        {
                            days: ''
                        },
                    ]
                },
                i94Expiry: {
                    whoWillSendReminder: [],
                    config: [
                        {
                            days: ''
                        },
                    ]
                },
                visaExpiry: {
                    whoWillSendReminder: [],
                    config: [
                        {
                            days: ''
                        },
                    ]
                },
                workAuthorizationExpiry: {
                    whoWillSendReminder: [],
                    config: [
                        {
                            days: ''
                        },
                    ]
                },
                totalStayIsNearing6Years: {
                    whoWillSendReminder: [],
                    config: [
                        {
                            days: ''
                        },
                    ]
                },
                caseSeleByUscisInLotteryDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                priorToExpiryDaysH1b: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },
                invoicePaymentReminder: {
                    whoWillSendReminder: [],
                    config: [
                        {
                            days: ''
                        },
                    ]
                },

                lcaSubAndQuestNotSubBriefDays: { 

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                pwdCertOrBeforeExpiryDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                lastAdvReleaseBriefDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                priorToExpiryPermDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                i140ApprovedDuringDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                gcEmpi485ApprovedDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                i130ApprovedDuringDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                gcfamilyi485ApprovedDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                priorToExpiryl1aOrl1b: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },

                l1i140ApprovedDuringDays: {

                    whoWillSendReminder: [],

                    config: [



                        {

                            days: ''

                        },

                    ]

                },
                globalStatus: [{
                    countryId: null,
                    countryDetails: null,
                    config: [
                        {
                            days: ''
                        },
                    ]
                }],

            }



        },

        configDetails: null,

        SubmtRminder: false,

        //linkShareToEmailList:[], 

        timeZoneList: [],

        seasonnYearError: '',
        uscisH1bReminderList:[],
        sponsorUserRolesList:[],
        renewalH1bReminderList:[],
        permH1bReminderList:[],
        gcEmploymentI485ReminderList:[],
        gcEmploymentN400ReminderList:[],
        gcfamilyflowI485ReminderList:[],
        gcfamilyflowN400ReminderList:[],
        renewalL1ReminderList:[],
        renewalL1I485ReminderList:[],
        invoiceReminderList:[],

    }),

    watch: {},

    methods: {
        setActive(selectedTab){
            if(selectedTab){
                this.activeTab=selectedTab.selectedTab
            }
          
        },
        updateCountryList(){
            // config['reminders']['globalStatus'][ind]['countryDetails']
            if(this.checkProperty(this.config['reminders'],'globalStatus', 'length')>0){
                let ids = [];
                _.forEach(this.config['reminders']['globalStatus'], (item)=>{
                    if(item && item['countryDetails'] && item['countryDetails']['id'] ){
                        ids.push(item['countryDetails']['id'])
                    }
                })
                // let ids = this.config['reminders']['globalStatus'].map(item => item.countryDetails['id']);
                let countryMaster = _.cloneDeep(this.countries);
                if(ids && ids.length>0){
                    let tempList = _.filter(countryMaster, (item)=>{
                        if(ids.indexOf(item['id'])<=-1){
                            return item
                        }
                    })
                    if(tempList){
                        this.filteredCountries = _.cloneDeep(tempList);
                    }else{
                        this.filteredCountries = [];
                    }
                    
                }else{
                    this.filteredCountries = _.cloneDeep(this.countries);
                }
            }else{
                this.filteredCountries = _.cloneDeep(this.countries);
            }
            
        },
        deleteSeason(val) {

            if (this.checkProperty(this.capSeasonEffectiveList, 'length') > 0) {

                let seasonFiltered = _.filter(this.capSeasonEffectiveList, (item) => {

                    if (item['seasonYear'] != val['seasonYear']) {

                        return item

                    }

                });

                this.capSeasonEffectiveList = _.cloneDeep(seasonFiltered);

                // this.seasonsYears.push(val['seasonYear']); 

                // let list = _.cloneDeep(this.seasonsYears); 

                // list.sort(function(a, b) { 

                //     return a - b; 

                // }); 

                // if(this.checkProperty(list, 'length')>0){ 

                //     this.seasonsYears = _.cloneDeep(list) 

                // } 

            }

        },

        addSeasonstoList() {

            this.$validator.validateAll('showAddseasonsPopup').then((result) => {

                if (result) {

                    this.seasonnYearError = '';

                    if (this.checkProperty(this.capSeasonEffectiveList, 'length') > 0) {

                        let findobj = _.find(this.capSeasonEffectiveList, { 'seasonYear': this.seletedObj['seasonYear'] });

                        if (findobj) {

                            this.seasonnYearError = 'Season year already exists'

                        }

                        if (!findobj) {

                            this.capSeasonEffectiveList.push(this.seletedObj);

                            // let seasonFiltered = _.filter(this.seasonsYears,(it)=>{ 

                            //     return it != this.seletedObj['seasonYear']; 

                            // }); 

                            // if(seasonFiltered){ 

                            //     this.seasonsYears = _.cloneDeep(seasonFiltered) 

                            // } 

                            this.addSeasonYears(false)

                        }

                    } else {

                        this.capSeasonEffectiveList.push(this.seletedObj);

                        // let seasonFiltered = _.filter(this.seasonsYears,(it)=>{ 

                        //     return it != this.seletedObj['seasonYear']; 

                        // }); 

                        // if(seasonFiltered){ 

                        //     this.seasonsYears = _.cloneDeep(seasonFiltered) 

                        // } 

                        this.addSeasonYears(false)

                    }



                }

            })

        },

        addSeasonYears(open = false) {

            this.$validator.reset();

            this.seletedObj = {

                seasonYear: null,

                effectiveDate: null,

            }

            this.seasonnYearError = '';

            if (open) {

                this.showAddseasonsPopup = true;

            } else {

                this.showAddseasonsPopup = false;

            }

        },

        getGraduatedYears() {

            this.seasonsYears = [];

            let currentYear = 2023;

            let futureYear = parseInt(currentYear) + 100

            for (let i = currentYear; i <= futureYear; i += 1) {

                //let item = {'id':i,'name':i} 

                this.seasonsYears.push(i)

            }

        },

        getAllSeasonsList() {

            this.allSesasonsList = [];

            this.capSeasonEffectiveList = [];

            this.$store.dispatch("getList", {

                data: { today: moment().format('YYYY-MM-DD') },

                path: "/cap-registrations/get-season-year-list",

            })

                .then((response) => {

                    if (response && this.checkProperty(response, 'length') > 0) {

                        _.forEach(response, (obj) => {

                            let seasonYear = { "name": obj, 'id': obj, }

                            this.allSesasonsList.push(seasonYear);

                            //this.allSesasonsList = this.checkProperty(response,'list'); 

                        });



                    }

                });

        },
        getUserRoles() {
            let postData = {
                page: 1,
                perpage: 10000,
                category: "user_roles",
                // tenantId: "5db7d79d6032453bd060ed9c", 
            }
            this.$store.dispatch("getMasterData", postData).then(response => {
                //this.allUserRoles = response.list;
                let userRolesList = response.list;
                let tempList = [];
          _.forEach(userRolesList, (item) => {
              tempList.push({
                roleId: item["id"],
                roleName: item["name"],
                uniqueId:item['id']+item['id']
              });
          });
          this.allUserRoles = tempList;

                this.allUserRoles = _.filter(this.allUserRoles, (rol) => {
                    return [1, 2].indexOf(rol['roleId']) <= -1
                })
                this.sponsorUserRolesList = _.filter(this.allUserRoles, (rol) => {
                    return [50,3,4,5,7,8,6].indexOf(rol['roleId']) > -1
                })
                this.uscisH1bReminderList = _.filter(this.allUserRoles, (rol) => {
                    return [50,3,4,5,7,8,6].indexOf(rol['roleId']) > -1
                }) 
                    this.renewalH1bReminderList = _.filter(this.allUserRoles, (rol) => {
                        return [50,3,4,5,7,8,6].indexOf(rol['roleId']) > -1
                    })
                    this.invoiceReminderList = _.filter(this.allUserRoles, (rol) => {
                        return [50].indexOf(rol['roleId']) > -1
                    })
                    this.permH1bReminderList = _.filter(this.allUserRoles, (rol) => {
                        return [50,3,4,5,7,8,6].indexOf(rol['roleId']) > -1
                    })
                    this.gcEmploymentI485ReminderList = _.filter(this.allUserRoles, (rol) => {
                        return [50,3,4,5,7,8,6].indexOf(rol['roleId']) > -1
                    })
                    if(this.getTenantTypeId==2){
                        this.passportExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                        return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                        })
                        this.i94ExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                            return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                        })
                        this.visaExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                            return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                        })
                        this.workAuthorizationExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                            return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                        })
                        this.pwdExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                            return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                        })
                        this.lengthOfStayUserRoles = _.filter(this.allUserRoles, (rol) => {
                            return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                        })
                    }else{
                        this.lengthOfStayUserRoles = _.filter(this.allUserRoles, (rol) => {
                        return [50,51].indexOf(rol['roleId']) > -1
                        })
                        this.passportExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                        return [50,51].indexOf(rol['roleId']) > -1
                        })
                        this.i94ExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                            return [50,51].indexOf(rol['roleId']) > -1
                        })
                        this.visaExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                            return [3,4,5,6,7,8,9,10,11,12,13,14,51,50].indexOf(rol['roleId']) > -1
                        })
                        this.workAuthorizationExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                            return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                        })
                        this.pwdExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
                            return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['roleId']) > -1
                        })
                    }
                   
                    // this.gcEmploymentN400ReminderList = _.filter(this.allUserRoles, (rol) => {

                    //     return [50,3,4,5,7,8,6].indexOf(rol['id']) > -1

                    // })
                    this.gcEmploymentN400ReminderList = _.concat(
                            _.filter(this.allUserRoles, (rol) => {
                                return [51, 3, 4, 5, 7, 8, 6].indexOf(rol['roleId']) > -1;
                            }),
                            { roleId: 51, name: 'Sponsor',sortName:'Sponsor' }
                        );
                    this.gcfamilyflowI485ReminderList = _.concat(
                            _.filter(this.allUserRoles, (rol) => {
                                return [51, 3, 4, 5, 7, 8, 6].indexOf(rol['roleId']) > -1;
                            }),
                            { roleId: 51, name: 'Sponsor',sortName:'Sponsor' }
                        );
                    this.gcfamilyflowN400ReminderList = _.filter(this.allUserRoles, (rol) => {

                        return [50,3,4,5,7,8,6].indexOf(rol['roleId']) > -1

                    })
                    this.renewalL1ReminderList = _.filter(this.allUserRoles, (rol) => {

                        return [50,3,4,5,7,8,6].indexOf(rol['roleId']) > -1

                    })
                    this.renewalL1I485ReminderList = _.filter(this.allUserRoles, (rol) => {

                        return [50,3,4,5,7,8,6].indexOf(rol['roleId']) > -1

                    })

                this.processHandlePwdActivityUsers();



            })

        },

        // getUserRoles() {
        //     let postData = {
        //         page: 1,
        //         perpage: 10000,
        //         category: "user_roles",
        //         // tenantId: "5db7d79d6032453bd060ed9c", 
        //     }
        //     this.$store.dispatch("getMasterData", postData).then(response => {
        //         this.allUserRoles = response.list;

        //         this.allUserRoles = _.filter(this.allUserRoles, (rol) => {

        //             return [1, 2].indexOf(rol['id']) <= -1

        //         })
        //         this.uscisH1bReminderList = _.filter(this.allUserRoles, (rol) => {
        //             return [50,3,4,5,7,8,6].indexOf(rol['id']) > -1
        //         })
        //             this.renewalH1bReminderList = _.filter(this.allUserRoles, (rol) => {
        //                 return [50,3,4,5,7,8,6].indexOf(rol['id']) > -1
        //             })
        //             this.permH1bReminderList = _.filter(this.allUserRoles, (rol) => {
        //                 return [50,3,4,5,7,8,6].indexOf(rol['id']) > -1
        //             })
        //             this.gcEmploymentI485ReminderList = _.filter(this.allUserRoles, (rol) => {
        //                 return [50,3,4,5,7,8,6].indexOf(rol['id']) > -1
        //             })
        //             if(this.getTenantTypeId==2){
        //                 this.passportExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
        //                 return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['id']) > -1
        //                 })
        //                 this.i94ExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
        //                     return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['id']) > -1
        //                 })
        //                 this.visaExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
        //                     return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['id']) > -1
        //                 })
        //                 this.workAuthorizationExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
        //                     return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['id']) > -1
        //                 })
        //             }else{
        //                 this.passportExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
        //                 return [50,51].indexOf(rol['id']) > -1
        //                 })
        //                 this.i94ExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
        //                     return [50,51].indexOf(rol['id']) > -1
        //                 })
        //                 this.visaExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
        //                     return [3,4,5,6,7,8,9,10,11,12,13,14,51,50].indexOf(rol['id']) > -1
        //                 })
        //                 this.workAuthorizationExpiryUserRoles = _.filter(this.allUserRoles, (rol) => {
        //                     return [3,4,5,6,7,8,9,10,11,12,13,14,51].indexOf(rol['id']) > -1
        //                 })
        //             }
                   
        //             // this.gcEmploymentN400ReminderList = _.filter(this.allUserRoles, (rol) => {

        //             //     return [50,3,4,5,7,8,6].indexOf(rol['id']) > -1

        //             // })
        //             this.gcEmploymentN400ReminderList = _.concat(
        //                     _.filter(this.allUserRoles, (rol) => {
        //                         return [51, 3, 4, 5, 7, 8, 6].indexOf(rol['id']) > -1;
        //                     }),
        //                     { id: 51, name: 'Sponsor',sortName:'Sponsor' }
        //                 );
        //             this.gcfamilyflowI485ReminderList = _.concat(
        //                     _.filter(this.allUserRoles, (rol) => {
        //                         return [51, 3, 4, 5, 7, 8, 6].indexOf(rol['id']) > -1;
        //                     }),
        //                     { id: 51, name: 'Sponsor',sortName:'Sponsor' }
        //                 );
        //             this.gcfamilyflowN400ReminderList = _.filter(this.allUserRoles, (rol) => {

        //                 return [50,3,4,5,7,8,6].indexOf(rol['id']) > -1

        //             })
        //             this.renewalL1ReminderList = _.filter(this.allUserRoles, (rol) => {

        //                 return [50,3,4,5,7,8,6].indexOf(rol['id']) > -1

        //             })
        //             this.renewalL1I485ReminderList = _.filter(this.allUserRoles, (rol) => {

        //                 return [50,3,4,5,7,8,6].indexOf(rol['id']) > -1

        //             })

        //         this.processHandlePwdActivityUsers();



        //     })

        // },

        getCourierList() {



            let postdata = {};

            this.$store

                .dispatch("getList", { data: postdata, path: "/tracking/courierlist" }).then((response) => {

                    if (this.checkProperty(response, "list")) {

                        this.masterCourierList = response['list'];

                    }

                    //this.optionCourierList = response; 

                    if (_.has(this.configDetails, "config.defaultCourierIds")) {

                        this.config['defaultCourierIds'] = this.configDetails['config']['defaultCourierIds'];

                        if (this.checkProperty(this.masterCourierList, 'length') > 0) {

                            this.config['defaultCourierDetails'] = _.filter(this.masterCourierList, (item) => {

                                return this.config['defaultCourierIds'].indexOf(item['id']) > -1

                            })



                        }

                    }



                });



        },

        checkInputValue(item, index) {

            item['showError'] = false;

            this.config['reminders']['pwdExpiry']['config'][index]['showError'] = false;

            let pitem = this.config['reminders']['pwdExpiry']['config'][index - 1];

            if (_.get(pitem, 'days')) {

                let pdays = _.get(pitem, 'days')

                let maxValue = parseInt(pdays) - 1;

                if (maxValue > 0) {

                    if (parseInt(item['days']) > parseInt(maxValue)) {

                        item['days'] = null;

                        item['showError'] = true;

                    }

                }

            }

        },
        checkPermInputValue(item, index) {
// alert(JSON.stringify(item))
// alert(JSON.stringify(index))
item['showError'] = false;

this.config['reminders']['priorToExpiryPermDays']['config'][index]['showError'] = false;

let pitem = this.config['reminders']['priorToExpiryPermDays']['config'][index - 1];

if (_.get(pitem, 'days')) {

    let pdays = _.get(pitem, 'days')

    let maxValue = parseInt(pdays) - 1;

    if (maxValue > 0) {

        if (parseInt(item['days']) > parseInt(maxValue)) {

            item['days'] = null;

            item['showError'] = true;

        }

    }

}

        },
        checkCoolingInputValue(item, index) {

        item['showError'] = false;

        this.config['reminders']['lastAdvReleaseBriefDays']['config'][index]['showError'] = false;

        let pitem = this.config['reminders']['lastAdvReleaseBriefDays']['config'][index - 1];

        if (_.get(pitem, 'days')) {

            let pdays = _.get(pitem, 'days')

            let maxValue = parseInt(pdays) - 1;

            if (maxValue > 0) {

                if (parseInt(item['days']) > parseInt(maxValue)) {

                    item['days'] = null;

                    item['showError'] = true;

                }

            }

        }

        },
        checkH1bInputValue(item, index) {

        item['showError'] = false;

        this.config['reminders']['priorToExpiryDaysH1b']['config'][index]['showError'] = false;

        let pitem = this.config['reminders']['priorToExpiryDaysH1b']['config'][index - 1];

        if (_.get(pitem, 'days')) {

            let pdays = _.get(pitem, 'days')

            let maxValue = parseInt(pdays) - 1;

            if (maxValue > 0) {

                if (parseInt(item['days']) > parseInt(maxValue)) {

                    item['days'] = null;

                    item['showError'] = true;

                }

            }

        }

        },
        checkInvoiceValue(item, index) {

            item['showError'] = false;

            this.config['reminders']['invoicePaymentReminder']['config'][index]['showError'] = false;

            let pitem = this.config['reminders']['invoicePaymentReminder']['config'][index - 1];

            if (_.get(pitem, 'days')) {

                let pdays = _.get(pitem, 'days')

                let maxValue = parseInt(pdays) - 1;

                if (maxValue > 0) {

                    if (parseInt(item['days']) > parseInt(maxValue)) {

                        item['days'] = null;

                        item['showError'] = true;

                    }

                }

            }

        },
        checkpriorInputValue(item, index) {

        item['showError'] = false;

        this.config['reminders']['priorToExpiryl1aOrl1b']['config'][index]['showError'] = false;

        let pitem = this.config['reminders']['priorToExpiryl1aOrl1b']['config'][index - 1];

        if (_.get(pitem, 'days')) {

            let pdays = _.get(pitem, 'days')

            let maxValue = parseInt(pdays) - 1;

            if (maxValue > 0) {

                if (parseInt(item['days']) > parseInt(maxValue)) {

                    item['days'] = null;

                    item['showError'] = true;

                }

            }

        }

        },
        checkInputI140Value(item, index, category) {

            item['showError'] = false;

            this.config['reminders'][category]['config'][index]['showError'] = false;

            let pitem = this.config['reminders'][category]['config'][index - 1];

            if (_.get(pitem, 'days')) {

                let pdays = _.get(pitem, 'days')

                let minValue = parseInt(pdays) + 1;

                if (minValue > 0) {

                    if (parseInt(item['days']) < parseInt(minValue)) {

                        item['days'] = null;

                        item['showError'] = true;

                    }

                }

            }

        },
        checkBenProfileValue(item, index, category) {
            this.$set(item, 'showError', false);
            this.$set(item, 'showNextError', false);
            //item['showError'] = false;
            this.config['reminders'][category]['config'][index]['showError'] = false;
            // Check against the previous entry
            let pitem = this.config['reminders'][category]['config'][index - 1];
            if (_.get(pitem, 'days')) {
                let pdays = _.get(pitem, 'days');
                let minValue = parseInt(pdays) - 1;
                if (minValue > 0) {
                    if (parseInt(item['days']) > parseInt(minValue)) {
                        item['days'] = null;
                        item['showError'] = true;
                    }
                }
            }
            // Check against the next entry
            let nitem = this.config['reminders'][category]['config'][index + 1];
            if (_.get(nitem, 'days')) {
                let ndays = _.get(nitem, 'days');
                let maxValue = parseInt(ndays) + 1;
                if (parseInt(item['days']) < parseInt(maxValue)) {
                    item['days'] = null;
                    item['showNextError'] = true;
                }
            }
        },
        // checkBenProfileValue(item, index, category) {
        //     item['showError'] = false;
        //     this.config['reminders'][category]['config'][index]['showError'] = false;
        //     let pitem = this.config['reminders'][category]['config'][index - 1];
        //     if (_.get(pitem, 'days')) {
        //         let pdays = _.get(pitem, 'days') 
        //         let minValue = parseInt(pdays) - 1;
        //         // let minValue = parseInt(pdays) + 1; < parseInt(minValue)
        //         if (minValue > 0) {
        //             if (parseInt(item['days']) > parseInt(minValue)) {
        //                 item['days'] = null;
        //                 item['showError'] = true;
        //             }
        //         }
        //     }
        // },
        checkGlobalValue(item, subInd, mainInd) {
            this.showGlobal = false
            item['showError'] = false;
            this.config['reminders']['globalStatus'][mainInd]['config'][subInd]['showError'] = false;
            let pitem = this.config['reminders']['globalStatus'][mainInd]['config'][subInd - 1];
            if (_.get(pitem, 'days')) {
                let pdays = _.get(pitem, 'days') 
                let minValue = parseInt(pdays) - 1;
                if (minValue > 0) {
                    if (parseInt(item['days']) > parseInt(minValue)) {
                        item['days'] = null;
                        item['showError'] = true;
                    }
                }
            }
            this.showGlobal = true
        },
        addGlobalConfigKeys(category='', ind){
            this.$validator.validateAll('globalStatus').then((result) => {
                let obj =   {
                    days: '',
                    showError: false,
                }
                let mainObj =   {
                    countryId: null,
                    countryDetails: null,
                    config:[
                        {
                            days: '',
                            showError: false,
                        }
                    ]
                }
                if(result){
                    this.showGlobal = false
                    if(category){
                        this.config['reminders']['globalStatus'][ind]['config'].push(obj);
                        this.config['reminders']['globalStatus'] = _.cloneDeep(this.config['reminders']['globalStatus']);
                        this.showGlobal = true
                    }else{
                        this.config['reminders']['globalStatus'].push(mainObj)
                        this.config['reminders']['globalStatus'] = _.cloneDeep(this.config['reminders']['globalStatus']);
                        this.showGlobal = true;
                        this.updateCountryList();
                    }
                    
                }
            })
        },
        removeStatusConfig(mainInd, subInd, category=''){
            this.showGlobal = false
            if (category) {
                this.config['reminders']['globalStatus'][mainInd]['config'].splice(subInd, 1);
                this.showGlobal = true
            }else{
                this.config['reminders']['globalStatus'].splice(mainInd, 1);
                this.showGlobal = true
            }
            this.updateCountryList()
            // this.config['reminders'][category]['config'].push();

        },
        updateVal(){
            this.showInvoice = false;
            let self = this;
            self.showInvoice = true;
        },
        removefilingfee: function (category, index) {

            // this.config['reminders'][category]['config'].splice(index, 1); 

            if (category) {

                this.config['reminders'][category]['config'].splice(index, 1);
                this.config['reminders'][category]['config'] = _.cloneDeep(this.config['reminders'][category]['config'])

            }
            this.showInvoice = false;
            let self = this;
            self.showInvoice = true;

        },

        addMoreKeys(category) {

            this.$validator.validateAll(category).then((result) => {



                if (result) {

                    // alert(result) 

                    // if(this.config&&this.config['reminders']&&this.config['reminders'][category]&&this.config['reminders'][category]['config']){ 

                    //     alert(result) 

                    //     this.config['reminders'][category]['config'].push( 

                    //     { 

                    //         days: '', 

                    //         showError:false, 

                    //     }, 

                    // ); 

                    // } 

                    //alert(JSON.stringify(this.config['reminders'])) 

                    this.config['reminders'][category]['config'].push(

                        {

                            days: '',

                            showError: false,

                        },

                    );
                    this.config['reminders'][category]['config'] = _.cloneDeep(this.config['reminders'][category]['config'])
                    this.showInvoice = false;
                    let self = this;
                    self.showInvoice = true;

                }

            });



        },

        formatEmail(assignValue = false) {



            // linkShareToemailsText:'', 

            // sharing:false, 

            let emailList = this.config['commuEmails'] && this.config['commuEmails'].split(',');

            this.linkShareToEmailList = [];

            let tempEmailList = [];

            if (this.checkProperty(emailList, 'length') > 0) {

                const validateEmail = (email) => {

                    return String(email)

                        .toLowerCase()

                        .match(

                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

                        );

                };



                this.linkShareToEmailList = _.filter(emailList, (email) => {

                    if (validateEmail(email)) {

                        return true;

                    } else {

                        return false;

                    }



                })

                if (assignValue) {

                    this.config['commuEmails'] = this.linkShareToEmailList.join(',');

                }
                // alert(JSON.stringify(this.linkShareToEmailList)); 
            }
        },

        updateQconfig() {
            this.formatEmail(true);
            this.$validator.validateAll('pwdExpiry')
            this.$validator.validateAll('i140')
            this.$validator.validateAll('caseSeleByUscisInLotteryDays') 
            this.$validator.validateAll('sponQuestionnire')
            this.$validator.validateAll('priorToExpiryDaysH1b')
            this.$validator.validateAll('invoicePaymentReminder')
            this.$validator.validateAll('lcaSubAndQuestNotSubBriefDays')
            this.$validator.validateAll('pwdCertOrBeforeExpiryDays')
            this.$validator.validateAll('lastAdvReleaseBriefDays')
            this.$validator.validateAll('priorToExpiryPermDays')
            this.$validator.validateAll('i140ApprovedDuringDays')
            this.$validator.validateAll('gcEmpi485ApprovedDays')
            this.$validator.validateAll('i130ApprovedDuringDays')
            this.$validator.validateAll('gcfamilyi485ApprovedDays')
            this.$validator.validateAll('priorToExpiryl1aOrl1b')
            this.$validator.validateAll('l1i140ApprovedDuringDays')//workAuthorizationExpiry
            this.$validator.validateAll('globalStatus').then((result)=>{
                if(result){
                    this.$validator.validateAll('passportExpiry').then((result)=>{
                    if(result){
                        this.$validator.validateAll('i94Expiry').then((result)=>{
                    if(result){
                        this.$validator.validateAll('pwdExpiry').then((result) => {
                    if (result) {
                        this.$validator.validateAll('pwdExpiry').then((result) => {
                            if (result) {
                                this.$validator.validateAll('sponQuestionnire').then((result) => {
                                    if (result) {
                                        this.$validator.validateAll('visaExpiry').then((result)=>{
                                        if(result){
                                            let path = "/global-config/create"
                                        if (this.checkProperty(this.configDetails, "_id")) {
                                            path = "/global-config/update"
                                        }
                                        let self = this;
                                        let config = _.cloneDeep(self.config);
                                        //  config['ptnrBriefDays'] = parseInt(config.ptnrBriefDays); 
                                        //  if(parseInt(config.ptnrBriefDays) <=0){ 
                                        //      config['ptnrBriefDays'] =null 
                                        //  } 
                                        //  config['benfSubQuestBriefDays'] = parseInt(config.benfSubQuestBriefDays); 
                                        //  if(parseInt(config.benfSubQuestBriefDays) <=0){ 
                                        //      config['benfSubQuestBriefDays'] =null 
                                        //  } 
                                        //  if(this.linkShareToEmailList.length>0){ 
                                        //      config['commuEmails'] =this.linkShareToEmailList.join(',') 
                                        //  } 
                                        //  if(!this.checkProperty(self.config ,"advCoolingPeriod")){ 
                                        //     self.config['advCoolingPeriod'] =0; 
                                        //    } 
                                        //    if(!this.checkProperty(self.config ,"advMinDuration")){ 
                                        //     self.config['advMinDuration'] =0; 
                                        //    }else if(this.checkProperty(self.config ,"advMinDuration") >0){ 
                                        //     self.config['advMinDuration'] = parseInt(self.config.advMinDuration); 
                                        //    } 
                                        if (this.checkProperty(self.config, "rfeCaseDeadlineDays") > 0) {
                                            self.config['rfeCaseDeadlineDays'] = parseInt(self.config.rfeCaseDeadlineDays);
                                        }
                                        //    if(this.checkProperty(self.config ,"caseSeleByUscisInLotteryDays") >0){ 
                                        //     self.config['caseSeleByUscisInLotteryDays'] = parseInt(self.config.caseSeleByUscisInLotteryDays); 
                                        //    } 
                                        this.configSaving = true;
                                        let postData = {
                                            "config": self.config
                                        }
                                        if (this.checkProperty(self.config, "currentSeasonYear", 'name')) {
                                            postData['config']['currentSeasonYear'] = self.config['currentSeasonYear']['name'];
                                        }
                                        if (_.has(this.configDetails, "config.mfaConfig")) {
                                            postData['config']['mfaConfig'] = this.configDetails['config']['mfaConfig'];
                                        }
                                        if (_.has(this.configDetails, "config.mfaRequired")) {
                                            postData['config']['mfaRequired'] = this.configDetails['config']['mfaRequired'];
                                        }
                                        if (this.checkProperty(self.configDetails, 'config',"enableI9Requests")) {
                                            postData['config']['enableI9Requests'] = self['configDetails']["config"]['enableI9Requests'];
                                        }
                                        if (this.checkProperty(self.configDetails, 'config',"enablePAFRequests")) {
                                            postData['config']['enablePAFRequests'] = self['configDetails']["config"]['enablePAFRequests'];
                                        }
                                        if (this.checkProperty(self.configDetails, 'config',"acceptConsentAndTAndC")) {
                                            postData['config']['acceptConsentAndTAndC'] = self['configDetails']["config"]['acceptConsentAndTAndC'];
                                        }
                                        if (_.has(postData.config['tenantDefaultTZ'], 'id')) {
                                            postData.config['tenantDefaultTZ'] = postData.config['tenantDefaultTZ']['id']
                                        }
                                        if (this.checkProperty(this.config, 'defaultCourierDetails', 'length') > 0) {
                                            postData.config['defaultCourierIds'] = _.map(this.config['defaultCourierDetails'], (item) => item.id) //this.checkProperty(this.config ,'defaultCourierDetails' ,'id') 
                                        }
                                        //GC-Employment, Gc-flow , L-1 reminders receivers(users) 
                                        if (this.checkProperty(this.config['reminders']['caseSeleByUscisInLotteryDays']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['caseSeleByUscisInLotteryDays']['whoWillSendReminder'] = this.config['reminders']['caseSeleByUscisInLotteryDays']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['pwdExpiry']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['pwdExpiry']['whoWillSendReminder'] = this.config['reminders']['pwdExpiry']['whoWillSendReminder']
                                        } 
                                        if (this.checkProperty(this.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder'] = this.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['invoicePaymentReminder']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['invoicePaymentReminder']['whoWillSendReminder'] = this.config['reminders']['invoicePaymentReminder']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['lcaSubAndQuestNotSubBriefDays']['whoWillSendReminder'] = this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['pwdCertOrBeforeExpiryDays']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['pwdCertOrBeforeExpiryDays']['whoWillSendReminder'] = this.config['reminders']['pwdCertOrBeforeExpiryDays']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['lastAdvReleaseBriefDays']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['lastAdvReleaseBriefDays']['whoWillSendReminder'] = this.config['reminders']['lastAdvReleaseBriefDays']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['priorToExpiryPermDays']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['priorToExpiryPermDays']['whoWillSendReminder'] = this.config['reminders']['priorToExpiryPermDays']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder'] = this.config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder'] = this.config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder'] = this.config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['gcfamilyi485ApprovedDays']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['gcfamilyi485ApprovedDays']['whoWillSendReminder'] = this.config['reminders']['gcfamilyi485ApprovedDays']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['priorToExpiryl1aOrl1b']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['priorToExpiryl1aOrl1b']['whoWillSendReminder'] = this.config['reminders']['priorToExpiryl1aOrl1b']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['passportExpiry']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['passportExpiry']['whoWillSendReminder'] = this.config['reminders']['passportExpiry']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['sponQuestionnire']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['sponQuestionnire']['whoWillSendReminder'] = this.config['reminders']['sponQuestionnire']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['i94Expiry']['whoWillSendReminder'], 'length') > 0) {
                                            //postData.config['reminders']['i94Expiry']['whoWillSendReminder'] = _.map(this.config['reminders']['i94Expiry']['whoWillSendReminder'], (item) => item.id)
                                            postData.config['reminders']['i94Expiry']['whoWillSendReminder'] = this.config['reminders']['i94Expiry']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder'] = this.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['totalStayIsNearing6Years']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['totalStayIsNearing6Years']['whoWillSendReminder'] = this.config['reminders']['totalStayIsNearing6Years']['whoWillSendReminder']
                                        }
                                        // else{
                                        //     postData.config['reminders']['totalStayIsNearing6Years']['whoWillSendReminder'] = []
                                        // }
                                        if (this.checkProperty(this.config['reminders']['visaExpiry']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['visaExpiry']['whoWillSendReminder'] = this.config['reminders']['visaExpiry']['whoWillSendReminder']
                                        }
                                        if (this.checkProperty(this.config['reminders']['l1i140ApprovedDuringDays']['whoWillSendReminder'], 'length') > 0) {
                                            postData.config['reminders']['l1i140ApprovedDuringDays']['whoWillSendReminder'] = this.config['reminders']['l1i140ApprovedDuringDays']['whoWillSendReminder']
                                        }
                                        //handlePwdActivityUsers   
                                        if (this.checkProperty(this.config, 'handlePwdActivityUsers', 'length') > 0) {
                                            postData.config['handlePwdActivityUsers'] = _.map(this.config['handlePwdActivityUsers'], (item) => item.id)
                                        }
                                        if (this.checkProperty(this.config, 'whoWillReassignCase', 'length') > 0) {
                                            postData.config['whoWillReassignCase'] = _.map(this.config['whoWillReassignCase'], (item) => item.id)
                                        }
                                        if (this.checkProperty(this.config, 'contactInfoOfG28Form') && this.checkProperty(this.config, 'contactInfoOfG28Form', 'id')) {
                                            postData.config['contactInfoOfG28Form'] = this.checkProperty(this.config, 'contactInfoOfG28Form', 'id')
                                        }
                                        //capSeasonConfig 
                                        if ([1].indexOf(this.getUserRoleId) > -1) {
                                            postData['config']['capSeasonConfig'] = this.capSeasonEffectiveList
                                        }
                                        this.$store.dispatch("commonAction", { data: postData, path: path })
                                            .then((response) => {
                                                this.configSaving = false;
                                                this.updateExternalCase(postData['config']['isAllowExternalCases'])
                                                this.showToster({ message: response.message, isError: false });
                                                this.getGlobalConfigDetails();
                                            })
                                            .catch((error) => {
                                                this.configSaving = false;
                                                this.showToster({ message: error, isError: true });
                                            });
                                        }
                                    })
                                    }
                                })
                            }
                        })
                    }
                })
                    }
                })
                    }
                })
                }
            })
                
           
           
        },
        updateExternalCase(action = false) {
            this.$store.commit('updateExternalCases', action);
        },
        ///global-config/details 
        // getGlobalConfigDetails() {
        //     let postData = {}
        //     //  this.configDetails =null 
        //     let path = 'global-config/details'
        //     this.$store.dispatch("commonAction", { data: postData, path: path })
        //         .then((response) => {
        //             this.configDetails = response;
        //             if ([1].indexOf(this.getUserRoleId) > -1) {
        //                 if (this.checkProperty(this.configDetails, "config", "capSeasonConfig") && this.checkProperty(this.configDetails['config'], 'capSeasonConfig', 'length') > 0) {
        //                     this.capSeasonEffectiveList = this.checkProperty(this.configDetails, "config", "capSeasonConfig");
        //                     if (this.capSeasonEffectiveList && this.checkProperty(this.capSeasonEffectiveList, 'length') > 0 && false) {
        //                         let list = this.capSeasonEffectiveList;
        //                         let yearArrayList = [];
        //                         _.forEach(list, (yr) => {
        //                             if (_.has(yr, 'seasonYear')) {
        //                                 let it = parseInt(yr['seasonYear'])
        //                                 yearArrayList.push(it);
        //                             }
        //                         });
        //                         if (this.checkProperty(yearArrayList, 'length') > 0 && this.checkProperty(this.seasonsYears, 'length') > 0) {
        //                             let seasonsFiltered = this.seasonsYears.filter(element => !yearArrayList.includes(element));
        //                             this.seasonsYears = _.cloneDeep(seasonsFiltered);
        //                         }
        //                     }
        //                 }
        //             }
        //             if (_.has(this.configDetails, "config.manageCapRegistrations")) {
        //                 this.config['manageCapRegistrations'] = this.configDetails['config']['manageCapRegistrations'];
        //                 this.$store.commit('updateManageCapRegistrations', this.config['manageCapRegistrations']);
        //             } else {
        //                 this.$store.commit('updateManageCapRegistrations', false);
        //             }
        //             if (this.checkProperty(this.configDetails, "config", "currentSeasonYear")) {
        //                 let year = this.checkProperty(this.configDetails, "config", "currentSeasonYear");
        //                 let currentSeasonYear = { "name": year, 'id': year };
        //                 this.config['currentSeasonYear'] = currentSeasonYear
        //             }
        //             if (this.checkProperty(this.configDetails, "config", "ptnrBriefDays")) {
        //                 this.config['ptnrBriefDays'] = this.checkProperty(this.configDetails, "config", "ptnrBriefDays");
        //             }
        //             if (this.checkProperty(this.configDetails, "config", "benfSubQuestBriefDays")) {
        //                 this.config['benfSubQuestBriefDays'] = this.checkProperty(this.configDetails, "config", "benfSubQuestBriefDays");
        //             }
                    
        //             //    if(this.checkProperty(this.configDetails ,"config" ,"caseSeleByUscisInLotteryDays" )){ 

        //             //        this.config['caseSeleByUscisInLotteryDays'] = this.checkProperty(this.configDetails ,"config" ,"caseSeleByUscisInLotteryDays" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"priorToExpiryDaysH1b" )){ 

        //             //        this.config['priorToExpiryDaysH1b'] = this.checkProperty(this.configDetails ,"config" ,"priorToExpiryDaysH1b" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"lcaSubAndQuestNotSubBriefDays" )){ 

        //             //        this.config['lcaSubAndQuestNotSubBriefDays'] = this.checkProperty(this.configDetails ,"config" ,"lcaSubAndQuestNotSubBriefDays" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"pwdCertOrBeforeExpiryDays" )){ 

        //             //        this.config['pwdCertOrBeforeExpiryDays'] = this.checkProperty(this.configDetails ,"config" ,"pwdCertOrBeforeExpiryDays" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"lastAdvReleaseBriefDays" )){ 

        //             //        this.config['lastAdvReleaseBriefDays'] = this.checkProperty(this.configDetails ,"config" ,"lastAdvReleaseBriefDays" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"priorToExpiryPermDays" )){ 

        //             //        this.config['priorToExpiryPermDays'] = this.checkProperty(this.configDetails ,"config" ,"priorToExpiryPermDays" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"i140ApprovedDuringDays" )){ 

        //             //        this.config['i140ApprovedDuringDays'] = this.checkProperty(this.configDetails ,"config" ,"i140ApprovedDuringDays" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"gcEmpi485ApprovedDays" )){ 

        //             //        this.config['gcEmpi485ApprovedDays'] = this.checkProperty(this.configDetails ,"config" ,"gcEmpi485ApprovedDays" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"i130ApprovedDuringDays" )){ 

        //             //        this.config['i130ApprovedDuringDays'] = this.checkProperty(this.configDetails ,"config" ,"i130ApprovedDuringDays" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"gcfamilyi485ApprovedDays" )){ 

        //             //        this.config['gcfamilyi485ApprovedDays'] = this.checkProperty(this.configDetails ,"config" ,"gcfamilyi485ApprovedDays" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"priorToExpiryl1aOrl1b" )){ 

        //             //        this.config['priorToExpiryl1aOrl1b'] = this.checkProperty(this.configDetails ,"config" ,"priorToExpiryl1aOrl1b" ); 

        //             //    } 

        //             //    if(this.checkProperty(this.configDetails ,"config" ,"l1i140ApprovedDuringDays" )){ 

        //             //        this.config['l1i140ApprovedDuringDays'] = this.checkProperty(this.configDetails ,"config" ,"l1i140ApprovedDuringDays" ); 

        //             //    } 

        //             if (_.has(this.configDetails, "config.allowCustonCaseNo")) {

        //                 this.config['allowCustonCaseNo'] = this.configDetails['config']['allowCustonCaseNo'];

        //             }

        //             if (_.has(this.configDetails, "config.usePtnrAddrAsMailingAddrInUSCISForms")) {

        //                 this.config['usePtnrAddrAsMailingAddrInUSCISForms'] = this.configDetails['config']['usePtnrAddrAsMailingAddrInUSCISForms'];

        //             }

        //             if (_.has(this.configDetails, "config.acceptCompayDocsForPtnr")) {

        //                 this.config['acceptCompayDocsForPtnr'] = this.configDetails['config']['acceptCompayDocsForPtnr'];

        //             }

        //             if (_.has(this.configDetails, "config.isAllowExternalCases")) {

        //                 this.config['isAllowExternalCases'] = this.configDetails['config']['isAllowExternalCases'];

        //             }

        //             if (_.has(this.configDetails, "config.requiredPinForQuesSubmit")) {

        //                 this.config['requiredPinForQuesSubmit'] = this.configDetails['config']['requiredPinForQuesSubmit'];

        //             }



        //             if (_.has(this.configDetails, "config.procefilPERMCoolNotMet")) {

        //                 this.config['procefilPERMCoolNotMet'] = this.configDetails['config']['procefilPERMCoolNotMet'];

        //             }

        //             if (_.has(this.configDetails, "config.petiApprovReqPWDDoc")) {

        //                 this.config['petiApprovReqPWDDoc'] = this.configDetails['config']['petiApprovReqPWDDoc'];

        //             }

        //             if (_.has(this.configDetails, "config.isPtnrActAsUSCISFormsPreparer")) {

        //                 this.config['isPtnrActAsUSCISFormsPreparer'] = this.configDetails['config']['isPtnrActAsUSCISFormsPreparer'];

        //             }

        //             if (_.has(this.configDetails['config'], 'contactInfoOfG28Form') && this.checkProperty(this.configDetails, 'config', 'contactInfoOfG28Form')) {

        //                 let dtVal = this.checkProperty(this.configDetails, 'config', 'contactInfoOfG28Form')

        //                 let findObj = _.find(this.contatctInfoList, { "id": dtVal })

        //                 this.config['contactInfoOfG28Form'] = findObj;



        //             } else {

        //                 let findObj = _.find(this.contatctInfoList, { "id": 'law_firm' })

        //                 if (findObj) {

        //                     this.config['contactInfoOfG28Form'] = findObj;

        //                 }

        //             }





        //             if (_.has(this.configDetails, "config.prefillCountryInQuestionnaire")) {

        //                 this.config['prefillCountryInQuestionnaire'] = this.configDetails['config']['prefillCountryInQuestionnaire'];

        //             }

        //             if (_.has(this.configDetails, "config.isI94DSExpiryDate")) {

        //                 this.config['isI94DSExpiryDate'] = this.configDetails['config']['isI94DSExpiryDate'];

        //             }



        //             if (_.has(this.configDetails, "config.allowToAddLCALayers")) {

        //                 this.config['allowToAddLCALayers'] = this.configDetails['config']['allowToAddLCALayers'];

        //             }



        //             if (_.has(this.configDetails, "config.addressEntityIOrHomeForLCA")) {

        //                 this.config['addressEntityIOrHomeForLCA'] = this.configDetails['config']['addressEntityIOrHomeForLCA'];

        //             }



        //             if (_.has(this.configDetails, "config.multipleJobDutiesForLCA")) {

        //                 this.config['multipleJobDutiesForLCA'] = this.configDetails['config']['multipleJobDutiesForLCA'];

        //             }

        //             if (_.has(this.configDetails, "config.multiEduDetailsForLCA")) {

        //                 this.config['multiEduDetailsForLCA'] = this.configDetails['config']['multiEduDetailsForLCA'];

        //             }



        //             if (_.has(this.configDetails, "config.yearsOfExpRequiredForLCA")) {

        //                 this.config['yearsOfExpRequiredForLCA'] = this.configDetails['config']['yearsOfExpRequiredForLCA'];

        //             }





        //             if (_.has(this.configDetails, "config.taskApprovalRequired")) {

        //                 this.config['taskApprovalRequired'] = this.configDetails['config']['taskApprovalRequired'];

        //             }

        //             if (_.has(this.configDetails, "config.requiredQBForInvoice")) {

        //                 this.config['requiredQBForInvoice'] = this.configDetails['config']['requiredQBForInvoice'];

        //             }

        //             if (_.has(this.configDetails, "commuEmails")) {

        //                 this.config['commuEmails'] = this.configDetails['commuEmails'];

        //                 this.formatEmail();

        //             }



        //             if (_.has(this.configDetails, "config.caseDeadlineDays")) {

        //                 this.config['caseDeadlineDays'] = this.configDetails['config']['caseDeadlineDays'];

        //             }

        //             if (_.has(this.configDetails, "config.rfeCaseDeadlineDays")) {

        //                 this.config['rfeCaseDeadlineDays'] = this.configDetails['config']['rfeCaseDeadlineDays'];

        //             }





        //             if (_.has(this.configDetails, "config.priorI94DeadlineDays")) {

        //                 this.config['priorI94DeadlineDays'] = this.configDetails['config']['priorI94DeadlineDays'];

        //             }

        //             if (_.has(this.configDetails, "config.remindPtnrInfoUpdateDays")) {

        //                 this.config['remindPtnrInfoUpdateDays'] = this.configDetails['config']['remindPtnrInfoUpdateDays'];

        //             }



        //             if (_.has(this.configDetails, "config.advCoolingPeriod")) {

        //                 this.config['advCoolingPeriod'] = this.configDetails['config']['advCoolingPeriod'];

        //             }

        //             if (_.has(this.configDetails, "config.advMinDuration")) {

        //                 this.config['advMinDuration'] = this.configDetails['config']['advMinDuration'];

        //             }



        //             if (_.has(this.configDetails, "config.priorFormsEffectiveDays")) {

        //                 this.config['priorFormsEffectiveDays'] = this.configDetails['config']['priorFormsEffectiveDays'];

        //             }

        //             if (_.has(this.configDetails, "config.permFileDaysAfterLastAdv")) {

        //                 this.config['permFileDaysAfterLastAdv'] = this.configDetails['config']['permFileDaysAfterLastAdv'];

        //             }



        //             if (_.has(this.configDetails, "config.tenantDefaultTZ")) {

        //                 let selectedTimeZone = _.find(this.timeZoneList, { 'id': this.configDetails['config']['tenantDefaultTZ'] });



        //                 this.config['tenantDefaultTZ'] = selectedTimeZone;

        //             }



        //             if (_.has(this.configDetails, "config.ptnrAttorneySignByInternal")) {

        //                 this.config['ptnrAttorneySignByInternal'] = this.configDetails['config']['ptnrAttorneySignByInternal'];

        //             }



        //             //addressEntityIOrHomeForLCA 

        //             if (_.has(this.configDetails, "config.addressEntityIOrHomeForLCA")) {

        //                 this.config['addressEntityIOrHomeForLCA'] = this.configDetails['config']['addressEntityIOrHomeForLCA'];

        //             }

        //             if (_.has(this.configDetails, "config.multipleJobDutiesForLCA")) {

        //                 this.config['multipleJobDutiesForLCA'] = this.configDetails['config']['multipleJobDutiesForLCA'];

        //             }

        //             if (_.has(this.configDetails, "config.multiEduDetailsForLCA")) {

        //                 this.config['multiEduDetailsForLCA'] = this.configDetails['config']['multiEduDetailsForLCA'];

        //             }

        //             //filingFeeCategoryType 

        //             if (_.has(this.configDetails, "config.filingFeeCategoryType")) {

        //                 this.config['filingFeeCategoryType'] = this.configDetails['config']['filingFeeCategoryType'];

        //             }

        //             //preSOCCodeMandatoryLCA 

        //             if (_.has(this.configDetails, "config.preSOCCodeMandatoryLCA")) {

        //                 this.config['preSOCCodeMandatoryLCA'] = this.configDetails['config']['preSOCCodeMandatoryLCA'];

        //             }





        //             //ptnrAttorneySignByInternal 



        //             // "defaultCourierIds":null, 

        //             //  defaultCourierDetails:null, 

        //             if (_.has(this.configDetails, "config.defaultCourierIds")) {

        //                 this.config['defaultCourierIds'] = this.configDetails['config']['defaultCourierIds'];

        //                 if (this.checkProperty(this.masterCourierList, 'length') > 0) {

        //                     this.config['defaultCourierDetails'] = _.filter(this.masterCourierList, (item) => {

        //                         return this.config['defaultCourierIds'].indexOf(item.id) > -1



        //                     })



        //                 }

        //             }





        //             this.config['reminders'] = {

        //                 pwdExpiry: {

        //                     config: [

        //                         {

        //                             days: '',

        //                             showError: false

        //                         },

        //                     ]

        //                 },

        //                 i140: {

        //                     config: [

        //                         {

        //                             days: '', showError: false

        //                         },

        //                     ]

        //                 },

        //                 sponQuestionnire: {
        //                     config: [
        //                         {

        //                             days: '', showError: false

        //                         },
        //                     ]
        //                 },
        //                 passportExpiry: {
        //                     whoWillSendReminder: [],
        //                     config: [
        //                         {

        //                             days: '', showError: false

        //                         },
        //                     ]
        //                 },
        //                 i94Expiry: {
        //                     whoWillSendReminder: [],
        //                     config: [
        //                         {

        //                             days: '', showError: false

        //                         },
        //                     ]
        //                 },
        //                 workAuthorizationExpiry: {
        //                     whoWillSendReminder: [],
        //                     config: [
        //                         {

        //                             days: '', showError: false

        //                         },
        //                     ]
        //                 },
        //                 visaExpiry: {
        //                     whoWillSendReminder: [],
        //                     config: [
        //                         {

        //                             days: '', showError: false

        //                         },
        //                     ]
        //                 },

        //                 caseSeleByUscisInLotteryDays: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 }

        //                 ,

        //                 priorToExpiryDaysH1b: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 },

        //                 lcaSubAndQuestNotSubBriefDays: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 },

        //                 pwdCertOrBeforeExpiryDays: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 },

        //                 lastAdvReleaseBriefDays: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 },

        //                 priorToExpiryPermDays: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 },

        //                 i140ApprovedDuringDays: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 },

        //                 gcEmpi485ApprovedDays: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 },

        //                 i130ApprovedDuringDays: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 },

        //                 gcfamilyi485ApprovedDays: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 },

        //                 priorToExpiryl1aOrl1b: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 },

        //                 l1i140ApprovedDuringDays: {

        //                     whoWillSendReminder: [],

        //                     config: [



        //                         {

        //                             days: ''

        //                         },

        //                     ]

        //                 }

        //             }

        //             if (_.has(this.configDetails, "config.reminders")) {

        //                 this.config['reminders'] = this.configDetails['config']['reminders'];

        //                 _.forEach(this.config['reminders']['pwdExpiry']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['i140']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['sponQuestionnire']['config'], (item) => {
        //                     item['showError'] = false
        //                 })
        //                 _.forEach(this.config['reminders']['passportExpiry']['config'], (item) => {
        //                     item['showError'] = false
        //                 })
        //                 _.forEach(this.config['reminders']['i94Expiry']['config'], (item) => {
        //                     item['showError'] = false
        //                 })
        //                 _.forEach(this.config['reminders']['visaExpiry']['config'], (item) => {
        //                     item['showError'] = false
        //                 })
        //                 _.forEach(this.config['reminders']['workAuthorizationExpiry']['config'], (item) => {
        //                     item['showError'] = false
        //                 })

        //                 _.forEach(this.config['reminders']['caseSeleByUscisInLotteryDays']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['priorToExpiryDaysH1b']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['pwdCertOrBeforeExpiryDays']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['lastAdvReleaseBriefDays']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['priorToExpiryPermDays']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['i140ApprovedDuringDays']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['gcEmpi485ApprovedDays']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['i130ApprovedDuringDays']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['gcfamilyi485ApprovedDays']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['priorToExpiryl1aOrl1b']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 _.forEach(this.config['reminders']['l1i140ApprovedDuringDays']['config'], (item) => {

        //                     item['showError'] = false

        //                 })

        //                 if (this.checkProperty(this.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder'], 'length') > 0) {
        //                     this.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder'] = _.filter(this.allUserRoles, (rol) => {
        //                         return this.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder'].indexOf(rol['id']) > -1
        //                     })
        //                 }
        //                 if (this.checkProperty(this.config['reminders']['priorToExpiryPermDays']['whoWillSendReminder'], 'length') > 0) {
        //                     this.config['reminders']['priorToExpiryPermDays']['whoWillSendReminder'] = _.filter(this.allUserRoles, (rol) => {
        //                         return this.config['reminders']['priorToExpiryPermDays']['whoWillSendReminder'].indexOf(rol['id']) > -1
        //                     })
        //                 }
        //                 if (this.checkProperty(this.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder'], 'length') > 0) {
        //                     this.config['reminders']['caseSeleByUscisInLotteryDays']['whoWillSendReminder'] = this.config['reminders']['caseSeleByUscisInLotteryDays']['whoWillSendReminder']
        //                 }
        //                 if (this.checkProperty(this.config['reminders']['passportExpiry']['whoWillSendReminder'], 'length') > 0) {
        //                     this.config['reminders']['passportExpiry']['whoWillSendReminder'] = this.config['reminders']['passportExpiry']['whoWillSendReminder']
                            
        //                 }
        //                 if (this.checkProperty(this.config['reminders']['i94Expiry']['whoWillSendReminder'], 'length') > 0) {
        //                     // this.config['reminders']['i94Expiry']['whoWillSendReminder'] = _.filter(this.allUserRoles, (rol) => {
        //                     //     return this.config['reminders']['i94Expiry']['whoWillSendReminder'].indexOf(rol['id']) > -1
        //                     // })
        //                     this.config['reminders']['i94Expiry']['whoWillSendReminder'] = this.config['reminders']['i94Expiry']['whoWillSendReminder']
                        
        //                 }
        //                 if (this.checkProperty(this.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder'], 'length') > 0) {
        //                     this.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder'] = this.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder']
        //                 }else{
        //                     this.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder'] = []
        //                 }
        //                 if (this.checkProperty(this.config['reminders']['visaExpiry']['whoWillSendReminder'], 'length') > 0) {
        //                     this.config['reminders']['visaExpiry']['whoWillSendReminder'] = this.config['reminders']['visaExpiry']['whoWillSendReminder']
        //                 }
        //                 if (this.checkProperty(this.config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder'], 'length') > 0) {
        //                     this.config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder'] = _.filter(this.allUserRoles, (rol) => {
        //                         return this.config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder'].indexOf(rol['id']) > -1
        //                     })
        //                 }
        //                 if (this.checkProperty(this.config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder'], 'length') > 0) {

        //                     this.config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder'] = _.filter(this.allUserRoles, (rol) => {

        //                         return this.config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder'].indexOf(rol['id']) > -1

        //                     })

        //                 }

        //                 if (this.checkProperty(this.config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder'], 'length') > 0) {

        //                     this.config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder'] = _.filter(this.allUserRoles, (rol) => {

        //                         return this.config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder'].indexOf(rol['id']) > -1

        //                     })

        //                 }

        //                 if (this.checkProperty(this.config['reminders']['gcfamilyi485ApprovedDays']['whoWillSendReminder'], 'length') > 0) {

        //                     this.config['reminders']['gcfamilyi485ApprovedDays']['whoWillSendReminder'] = _.filter(this.allUserRoles, (rol) => {

        //                         return this.config['reminders']['gcfamilyi485ApprovedDays']['whoWillSendReminder'].indexOf(rol['id']) > -1

        //                     })

        //                 }

        //                 if (this.checkProperty(this.config['reminders']['priorToExpiryl1aOrl1b']['whoWillSendReminder'], 'length') > 0) {

        //                     this.config['reminders']['priorToExpiryl1aOrl1b']['whoWillSendReminder'] = _.filter(this.allUserRoles, (rol) => {

        //                         return this.config['reminders']['priorToExpiryl1aOrl1b']['whoWillSendReminder'].indexOf(rol['id']) > -1

        //                     })

        //                 }

        //                 if (this.checkProperty(this.config['reminders']['l1i140ApprovedDuringDays']['whoWillSendReminder'], 'length') > 0) {

        //                     this.config['reminders']['l1i140ApprovedDuringDays']['whoWillSendReminder'] = _.filter(this.allUserRoles, (rol) => {

        //                         return this.config['reminders']['l1i140ApprovedDuringDays']['whoWillSendReminder'].indexOf(rol['id']) > -1

        //                     })

        //                 }

        //             }

        //             if (this.config['reminders']['pwdExpiry']['config'].length <= 0) {

        //                 this.config['reminders']['pwdExpiry']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['i140']['config'].length <= 0) {

        //                 this.config['reminders']['i140']['config'] = [{ days: '', showError: false }]

        //             }
        //             if (this.config['reminders']['sponQuestionnire']['config'].length <= 0) {
        //                 this.config['reminders']['sponQuestionnire']['config'] = [{ days: '', showError: false }]
        //             }
        //             if (this.config['reminders']['passportExpiry']['config'].length <= 0) {
        //                 this.config['reminders']['passportExpiry']['config'] = [{ days: '', showError: false }]
        //             }
        //             if (this.config['reminders']['i94Expiry']['config'].length <= 0) {
        //                 this.config['reminders']['i94Expiry']['config'] = [{ days: '', showError: false }]
        //             }
        //             if (this.config['reminders']['workAuthorizationExpiry']['config'].length <= 0) {
        //                 this.config['reminders']['workAuthorizationExpiry']['config'] = [{ days: '', showError: false }]
        //             }
        //             if (this.config['reminders']['visaExpiry']['config'].length <= 0) {
        //                 this.config['reminders']['visaExpiry']['config'] = [{ days: '', showError: false }]
        //             }
        //             if (this.config['reminders']['caseSeleByUscisInLotteryDays']['config'].length <= 0) {

        //                 this.config['reminders']['caseSeleByUscisInLotteryDays']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['priorToExpiryDaysH1b']['config'].length <= 0) {

        //                 this.config['reminders']['priorToExpiryDaysH1b']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['config'].length <= 0) {

        //                 this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['pwdCertOrBeforeExpiryDays']['config'].length <= 0) {

        //                 this.config['reminders']['pwdCertOrBeforeExpiryDays']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['lastAdvReleaseBriefDays']['config'].length <= 0) {

        //                 this.config['reminders']['lastAdvReleaseBriefDays']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['priorToExpiryPermDays']['config'].length <= 0) {

        //                 this.config['reminders']['priorToExpiryPermDays']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['i140ApprovedDuringDays']['config'].length <= 0) {

        //                 this.config['reminders']['i140ApprovedDuringDays']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['gcEmpi485ApprovedDays']['config'].length <= 0) {

        //                 this.config['reminders']['gcEmpi485ApprovedDays']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['i130ApprovedDuringDays']['config'].length <= 0) {

        //                 this.config['reminders']['i130ApprovedDuringDays']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['gcfamilyi485ApprovedDays']['config'].length <= 0) {

        //                 this.config['reminders']['gcfamilyi485ApprovedDays']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['priorToExpiryl1aOrl1b']['config'].length <= 0) {

        //                 this.config['reminders']['priorToExpiryl1aOrl1b']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.config['reminders']['l1i140ApprovedDuringDays']['config'].length <= 0) {

        //                 this.config['reminders']['l1i140ApprovedDuringDays']['config'] = [{ days: '', showError: false }]

        //             }

        //             if (this.checkProperty(this.configDetails, 'config', 'handlePwdActivityUsers')) {

        //                 this.processHandlePwdActivityUsers();

        //                 // handlePwdActivityUsers 

        //             }

        //             if (_.has(this.configDetails['config'], 'whoWillReassignCase') && this.checkProperty(this.configDetails, 'config', 'whoWillReassignCase')) {

        //                 this.processwhoWillReassignCase();

        //             } else {

        //                 let findObj = _.find(this.allUserRoles, { "id": 3 })

        //                 if (findObj) {

        //                     this.configDetails['config']['whoWillReassignCase'].push(findObj)

        //                 }

        //             }



        //         })





        // },
        getGlobalConfigDetails() {
            let postData = {}
            //  this.configDetails =null 
            let path = 'global-config/details'
            this.$store.dispatch("commonAction", { data: postData, path: path })
                .then((response) => {
                    this.configDetails = response;
                    if ([1].indexOf(this.getUserRoleId) > -1) {
                        if (this.checkProperty(this.configDetails, "config", "capSeasonConfig") && this.checkProperty(this.configDetails['config'], 'capSeasonConfig', 'length') > 0) {
                            this.capSeasonEffectiveList = this.checkProperty(this.configDetails, "config", "capSeasonConfig");
                            if (this.capSeasonEffectiveList && this.checkProperty(this.capSeasonEffectiveList, 'length') > 0 && false) {
                                let list = this.capSeasonEffectiveList;
                                let yearArrayList = [];
                                _.forEach(list, (yr) => {
                                    if (_.has(yr, 'seasonYear')) {
                                        let it = parseInt(yr['seasonYear'])
                                        yearArrayList.push(it);
                                    }
                                });
                                if (this.checkProperty(yearArrayList, 'length') > 0 && this.checkProperty(this.seasonsYears, 'length') > 0) {
                                    let seasonsFiltered = this.seasonsYears.filter(element => !yearArrayList.includes(element));
                                    this.seasonsYears = _.cloneDeep(seasonsFiltered);
                                }
                            }
                        }
                    }
                    if (_.has(this.configDetails, "config.manageCapRegistrations")) {
                        this.config['manageCapRegistrations'] = this.configDetails['config']['manageCapRegistrations'];
                        this.$store.commit('updateManageCapRegistrations', this.config['manageCapRegistrations']);
                    } else {
                        this.$store.commit('updateManageCapRegistrations', false);
                    }
                    if (this.checkProperty(this.configDetails, "config", "currentSeasonYear")) {
                        let year = this.checkProperty(this.configDetails, "config", "currentSeasonYear");
                        let currentSeasonYear = { "name": year, 'id': year };
                        this.config['currentSeasonYear'] = currentSeasonYear
                    }
                    if (this.checkProperty(this.configDetails, "config", "ptnrBriefDays")) {
                        this.config['ptnrBriefDays'] = this.checkProperty(this.configDetails, "config", "ptnrBriefDays");
                    }
                    if (this.checkProperty(this.configDetails, "config", "benfSubQuestBriefDays")) {
                        this.config['benfSubQuestBriefDays'] = this.checkProperty(this.configDetails, "config", "benfSubQuestBriefDays");
                    }
                    
                    //    if(this.checkProperty(this.configDetails ,"config" ,"caseSeleByUscisInLotteryDays" )){ 

                    //        this.config['caseSeleByUscisInLotteryDays'] = this.checkProperty(this.configDetails ,"config" ,"caseSeleByUscisInLotteryDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"priorToExpiryDaysH1b" )){ 

                    //        this.config['priorToExpiryDaysH1b'] = this.checkProperty(this.configDetails ,"config" ,"priorToExpiryDaysH1b" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"lcaSubAndQuestNotSubBriefDays" )){ 

                    //        this.config['lcaSubAndQuestNotSubBriefDays'] = this.checkProperty(this.configDetails ,"config" ,"lcaSubAndQuestNotSubBriefDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"pwdCertOrBeforeExpiryDays" )){ 

                    //        this.config['pwdCertOrBeforeExpiryDays'] = this.checkProperty(this.configDetails ,"config" ,"pwdCertOrBeforeExpiryDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"lastAdvReleaseBriefDays" )){ 

                    //        this.config['lastAdvReleaseBriefDays'] = this.checkProperty(this.configDetails ,"config" ,"lastAdvReleaseBriefDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"priorToExpiryPermDays" )){ 

                    //        this.config['priorToExpiryPermDays'] = this.checkProperty(this.configDetails ,"config" ,"priorToExpiryPermDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"i140ApprovedDuringDays" )){ 

                    //        this.config['i140ApprovedDuringDays'] = this.checkProperty(this.configDetails ,"config" ,"i140ApprovedDuringDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"gcEmpi485ApprovedDays" )){ 

                    //        this.config['gcEmpi485ApprovedDays'] = this.checkProperty(this.configDetails ,"config" ,"gcEmpi485ApprovedDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"i130ApprovedDuringDays" )){ 

                    //        this.config['i130ApprovedDuringDays'] = this.checkProperty(this.configDetails ,"config" ,"i130ApprovedDuringDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"gcfamilyi485ApprovedDays" )){ 

                    //        this.config['gcfamilyi485ApprovedDays'] = this.checkProperty(this.configDetails ,"config" ,"gcfamilyi485ApprovedDays" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"priorToExpiryl1aOrl1b" )){ 

                    //        this.config['priorToExpiryl1aOrl1b'] = this.checkProperty(this.configDetails ,"config" ,"priorToExpiryl1aOrl1b" ); 

                    //    } 

                    //    if(this.checkProperty(this.configDetails ,"config" ,"l1i140ApprovedDuringDays" )){ 

                    //        this.config['l1i140ApprovedDuringDays'] = this.checkProperty(this.configDetails ,"config" ,"l1i140ApprovedDuringDays" ); 

                    //    }

                    if (_.has(this.configDetails, "config.allowCustonCaseNo")) {

                        this.config['allowCustonCaseNo'] = this.configDetails['config']['allowCustonCaseNo'];

                    }
                    if (_.has(this.configDetails, "config.showCaseDeadLineDateforPetitioner")) {

                    this.config['showCaseDeadLineDateforPetitioner'] = this.configDetails['config']['showCaseDeadLineDateforPetitioner'];

                    }

                    if (_.has(this.configDetails, "config.usePtnrAddrAsMailingAddrInUSCISForms")) {

                        this.config['usePtnrAddrAsMailingAddrInUSCISForms'] = this.configDetails['config']['usePtnrAddrAsMailingAddrInUSCISForms'];

                    }

                    if (_.has(this.configDetails, "config.acceptCompayDocsForPtnr")) {

                        this.config['acceptCompayDocsForPtnr'] = this.configDetails['config']['acceptCompayDocsForPtnr'];

                    }

                    if (_.has(this.configDetails, "config.isAllowExternalCases")) {

                        this.config['isAllowExternalCases'] = this.configDetails['config']['isAllowExternalCases'];

                    }

                    if (_.has(this.configDetails, "config.requiredPinForQuesSubmit")) {

                        this.config['requiredPinForQuesSubmit'] = this.configDetails['config']['requiredPinForQuesSubmit'];

                    }



                    if (_.has(this.configDetails, "config.procefilPERMCoolNotMet")) {

                        this.config['procefilPERMCoolNotMet'] = this.configDetails['config']['procefilPERMCoolNotMet'];

                    }

                    if (_.has(this.configDetails, "config.petiApprovReqPWDDoc")) {

                        this.config['petiApprovReqPWDDoc'] = this.configDetails['config']['petiApprovReqPWDDoc'];

                    }

                    if (_.has(this.configDetails, "config.isPtnrActAsUSCISFormsPreparer")) {

                        this.config['isPtnrActAsUSCISFormsPreparer'] = this.configDetails['config']['isPtnrActAsUSCISFormsPreparer'];

                    }

                    if (_.has(this.configDetails['config'], 'contactInfoOfG28Form') && this.checkProperty(this.configDetails, 'config', 'contactInfoOfG28Form')) {

                        let dtVal = this.checkProperty(this.configDetails, 'config', 'contactInfoOfG28Form')

                        let findObj = _.find(this.contatctInfoList, { "id": dtVal })

                        this.config['contactInfoOfG28Form'] = findObj;



                    } else {

                        let findObj = _.find(this.contatctInfoList, { "id": 'law_firm' })

                        if (findObj) {

                            this.config['contactInfoOfG28Form'] = findObj;

                        }

                    }





                    if (_.has(this.configDetails, "config.prefillCountryInQuestionnaire")) {

                        this.config['prefillCountryInQuestionnaire'] = this.configDetails['config']['prefillCountryInQuestionnaire'];

                    }

                    if (_.has(this.configDetails, "config.isI94DSExpiryDate")) {

                        this.config['isI94DSExpiryDate'] = this.configDetails['config']['isI94DSExpiryDate'];

                    }



                    if (_.has(this.configDetails, "config.allowToAddLCALayers")) {

                        this.config['allowToAddLCALayers'] = this.configDetails['config']['allowToAddLCALayers'];

                    }



                    if (_.has(this.configDetails, "config.addressEntityIOrHomeForLCA")) {

                        this.config['addressEntityIOrHomeForLCA'] = this.configDetails['config']['addressEntityIOrHomeForLCA'];

                    }



                    if (_.has(this.configDetails, "config.multipleJobDutiesForLCA")) {

                        this.config['multipleJobDutiesForLCA'] = this.configDetails['config']['multipleJobDutiesForLCA'];

                    }

                    if (_.has(this.configDetails, "config.multiEduDetailsForLCA")) {

                        this.config['multiEduDetailsForLCA'] = this.configDetails['config']['multiEduDetailsForLCA'];

                    }



                    if (_.has(this.configDetails, "config.yearsOfExpRequiredForLCA")) {

                        this.config['yearsOfExpRequiredForLCA'] = this.configDetails['config']['yearsOfExpRequiredForLCA'];

                    }





                    if (_.has(this.configDetails, "config.taskApprovalRequired")) {

                        this.config['taskApprovalRequired'] = this.configDetails['config']['taskApprovalRequired'];

                    }

                    if (_.has(this.configDetails, "config.requiredQBForInvoice")) {

                        this.config['requiredQBForInvoice'] = this.configDetails['config']['requiredQBForInvoice'];

                    }

                    if (_.has(this.configDetails, "commuEmails")) {

                        this.config['commuEmails'] = this.configDetails['commuEmails'];

                        this.formatEmail();

                    }



                    if (_.has(this.configDetails, "config.caseDeadlineDays")) {

                        this.config['caseDeadlineDays'] = this.configDetails['config']['caseDeadlineDays'];

                    }

                    if (_.has(this.configDetails, "config.rfeCaseDeadlineDays")) {

                        this.config['rfeCaseDeadlineDays'] = this.configDetails['config']['rfeCaseDeadlineDays'];

                    }





                    if (_.has(this.configDetails, "config.priorI94DeadlineDays")) {

                        this.config['priorI94DeadlineDays'] = this.configDetails['config']['priorI94DeadlineDays'];

                    }

                    if (_.has(this.configDetails, "config.remindPtnrInfoUpdateDays")) {

                        this.config['remindPtnrInfoUpdateDays'] = this.configDetails['config']['remindPtnrInfoUpdateDays'];

                    }



                    if (_.has(this.configDetails, "config.advCoolingPeriod")) {

                        this.config['advCoolingPeriod'] = this.configDetails['config']['advCoolingPeriod'];

                    }

                    if (_.has(this.configDetails, "config.advMinDuration")) {

                        this.config['advMinDuration'] = this.configDetails['config']['advMinDuration'];

                    }



                    if (_.has(this.configDetails, "config.priorFormsEffectiveDays")) {

                        this.config['priorFormsEffectiveDays'] = this.configDetails['config']['priorFormsEffectiveDays'];

                    }

                    if (_.has(this.configDetails, "config.permFileDaysAfterLastAdv")) {

                        this.config['permFileDaysAfterLastAdv'] = this.configDetails['config']['permFileDaysAfterLastAdv'];

                    }



                    if (_.has(this.configDetails, "config.tenantDefaultTZ")) {

                        let selectedTimeZone = _.find(this.timeZoneList, { 'id': this.configDetails['config']['tenantDefaultTZ'] });



                        this.config['tenantDefaultTZ'] = selectedTimeZone;

                    }



                    if (_.has(this.configDetails, "config.ptnrAttorneySignByInternal")) {

                        this.config['ptnrAttorneySignByInternal'] = this.configDetails['config']['ptnrAttorneySignByInternal'];

                    }



                    //addressEntityIOrHomeForLCA 

                    if (_.has(this.configDetails, "config.addressEntityIOrHomeForLCA")) {

                        this.config['addressEntityIOrHomeForLCA'] = this.configDetails['config']['addressEntityIOrHomeForLCA'];

                    }

                    if (_.has(this.configDetails, "config.multipleJobDutiesForLCA")) {

                        this.config['multipleJobDutiesForLCA'] = this.configDetails['config']['multipleJobDutiesForLCA'];

                    }

                    if (_.has(this.configDetails, "config.multiEduDetailsForLCA")) {

                        this.config['multiEduDetailsForLCA'] = this.configDetails['config']['multiEduDetailsForLCA'];

                    }

                    //filingFeeCategoryType 

                    if (_.has(this.configDetails, "config.filingFeeCategoryType")) {

                        this.config['filingFeeCategoryType'] = this.configDetails['config']['filingFeeCategoryType'];

                    }

                    //preSOCCodeMandatoryLCA 

                    if (_.has(this.configDetails, "config.preSOCCodeMandatoryLCA")) {

                        this.config['preSOCCodeMandatoryLCA'] = this.configDetails['config']['preSOCCodeMandatoryLCA'];

                    }





                    //ptnrAttorneySignByInternal 



                    // "defaultCourierIds":null, 

                    //  defaultCourierDetails:null, 

                    if (_.has(this.configDetails, "config.defaultCourierIds")) {

                        this.config['defaultCourierIds'] = this.configDetails['config']['defaultCourierIds'];

                        if (this.checkProperty(this.masterCourierList, 'length') > 0) {

                            this.config['defaultCourierDetails'] = _.filter(this.masterCourierList, (item) => {

                                return this.config['defaultCourierIds'].indexOf(item.id) > -1



                            })



                        }

                    }





                    this.config['reminders'] = {

                        pwdExpiry: {
                            whoWillSendReminder: [],
                            config: [

                                {

                                    days: '',

                                    showError: false

                                },

                            ]

                        },

                        i140: {

                            config: [

                                {

                                    days: '', showError: false

                                },

                            ]

                        },

                        sponQuestionnire: {
                            whoWillSendReminder: [],
                            config: [
                                {

                                    days: '', showError: false

                                },
                            ]
                        },
                        passportExpiry: {
                            whoWillSendReminder: [],
                            config: [
                                {

                                    days: '', showError: false

                                },
                            ]
                        },
                        i94Expiry: {
                            whoWillSendReminder: [],
                            config: [
                                {

                                    days: '', showError: false

                                },
                            ]
                        },
                        totalStayIsNearing6Years: {
                            whoWillSendReminder: [],
                            config: [
                                {

                                    days: '', showError: false

                                },
                            ]
                        },
                        workAuthorizationExpiry: {
                            whoWillSendReminder: [],
                            config: [
                                {

                                    days: '', showError: false

                                },
                            ]
                        },
                        visaExpiry: {
                            whoWillSendReminder: [],
                            config: [
                                {

                                    days: '', showError: false

                                },
                            ]
                        },

                        caseSeleByUscisInLotteryDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        }, 

                        priorToExpiryDaysH1b: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },
                        invoicePaymentReminder: {
                            whoWillSendReminder: [],
                            config: [
                                {
                                    days: ''
                                },
                            ]
                        },
                        lcaSubAndQuestNotSubBriefDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        pwdCertOrBeforeExpiryDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        lastAdvReleaseBriefDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        priorToExpiryPermDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        i140ApprovedDuringDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        gcEmpi485ApprovedDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        i130ApprovedDuringDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        gcfamilyi485ApprovedDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        priorToExpiryl1aOrl1b: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },

                        l1i140ApprovedDuringDays: {

                            whoWillSendReminder: [],

                            config: [



                                {

                                    days: ''

                                },

                            ]

                        },
                        globalStatus: [{
                            countryId: null,
                            countryDetails: null,
                            config: [
                                {
                                    days: ''
                                },
                            ]
                        }],

                    }

                    if (_.has(this.configDetails, "config.reminders")) {

                        this.config['reminders'] = this.configDetails['config']['reminders'];

                        _.forEach(this.config['reminders']['pwdExpiry']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['i140']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['sponQuestionnire']['config'], (item) => {
                            item['showError'] = false
                        })
                        _.forEach(this.config['reminders']['passportExpiry']['config'], (item) => {
                            item['showError'] = false
                        })
                        _.forEach(this.config['reminders']['i94Expiry']['config'], (item) => {
                            item['showError'] = false
                        })
                        _.forEach(this.config['reminders']['visaExpiry']['config'], (item) => {
                            item['showError'] = false
                        })
                        _.forEach(this.config['reminders']['workAuthorizationExpiry']['config'], (item) => {
                            item['showError'] = false
                        })
                        _.forEach(this.config['reminders']['totalStayIsNearing6Years']['config'], (item) => {
                            item['showError'] = false
                        })

                        _.forEach(this.config['reminders']['caseSeleByUscisInLotteryDays']['config'], (item) => {

                            item['showError'] = false
 
                        }) 

                        _.forEach(this.config['reminders']['priorToExpiryDaysH1b']['config'], (item) => {

                            item['showError'] = false

                        })
                        

                        _.forEach(this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['pwdCertOrBeforeExpiryDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['lastAdvReleaseBriefDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['priorToExpiryPermDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['i140ApprovedDuringDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['gcEmpi485ApprovedDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['i130ApprovedDuringDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['gcfamilyi485ApprovedDays']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['priorToExpiryl1aOrl1b']['config'], (item) => {

                            item['showError'] = false

                        })

                        _.forEach(this.config['reminders']['l1i140ApprovedDuringDays']['config'], (item) => {

                            item['showError'] = false

                        })
                        if(this.checkProperty(this.config['reminders']['invoicePaymentReminder']['config'], 'length') > 0){
                            _.forEach(this.config['reminders']['invoicePaymentReminder']['config'], (item) => {
                                item['showError'] = false
                            })
                        }
                        if (this.checkProperty(this.config['reminders']['pwdExpiry']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['pwdExpiry']['whoWillSendReminder'] = this.config['reminders']['pwdExpiry']['whoWillSendReminder']
                        }else{
                            this.config['reminders']['pwdExpiry']['whoWillSendReminder'] = []
                        } 
                        if(!_.has(this.config['reminders'], 'invoicePaymentReminder')){
                            this.config['reminders']['invoicePaymentReminder'] = {};
                            this.config['reminders']['invoicePaymentReminder'] =  {
                                whoWillSendReminder: [],
                                config: [
                                    {
                                        days: ''
                                    },
                                ]
                                
                            }
                        }else{
                            if (this.checkProperty(this.config['reminders']['invoicePaymentReminder']['whoWillSendReminder'], 'length') > 0) {
                                this.config['reminders']['invoicePaymentReminder']['whoWillSendReminder'] = this.config['reminders']['invoicePaymentReminder']['whoWillSendReminder'];
                            }else{
                                this.config['reminders']['invoicePaymentReminder']['whoWillSendReminder'] = []
                            }
                        }
                        if (this.checkProperty(this.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder'] = this.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder']
                        }else{
                            this.config['reminders']['priorToExpiryDaysH1b']['whoWillSendReminder'] = []
                        }
                        if (this.checkProperty(this.config['reminders']['priorToExpiryPermDays']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['priorToExpiryPermDays']['whoWillSendReminder'] = this.config['reminders']['priorToExpiryPermDays']['whoWillSendReminder']
                        }else{
                            this.config['reminders']['priorToExpiryPermDays']['whoWillSendReminder'] = []
                        }
                        if (this.checkProperty(this.config['reminders']['caseSeleByUscisInLotteryDays']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['caseSeleByUscisInLotteryDays']['whoWillSendReminder'] = this.config['reminders']['caseSeleByUscisInLotteryDays']['whoWillSendReminder']
                        }else{
                            this.config['reminders']['caseSeleByUscisInLotteryDays']['whoWillSendReminder'] = []
                        }
                        if (this.checkProperty(this.config['reminders']['passportExpiry']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['passportExpiry']['whoWillSendReminder'] = this.config['reminders']['passportExpiry']['whoWillSendReminder']
                            
                        }else{
                            this.config['reminders']['passportExpiry']['whoWillSendReminder'] = []
                        }
                        if (this.checkProperty(this.config['reminders']['sponQuestionnire']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['sponQuestionnire']['whoWillSendReminder'] = this.config['reminders']['sponQuestionnire']['whoWillSendReminder']
                            
                        }else{
                            this.config['reminders']['sponQuestionnire']['whoWillSendReminder'] = []
                        }
                        if (this.checkProperty(this.config['reminders']['i94Expiry']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['i94Expiry']['whoWillSendReminder'] = this.config['reminders']['i94Expiry']['whoWillSendReminder']
                        }else{
                            this.config['reminders']['i94Expiry']['whoWillSendReminder'] = []
                        }
                        if (this.checkProperty(this.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder'] = this.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder']
                        }else{
                            this.config['reminders']['workAuthorizationExpiry']['whoWillSendReminder'] = []
                        }
                        if (this.checkProperty(this.config['reminders']['totalStayIsNearing6Years']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['totalStayIsNearing6Years']['whoWillSendReminder'] = this.config['reminders']['totalStayIsNearing6Years']['whoWillSendReminder']
                        }else{
                            this.config['reminders']['totalStayIsNearing6Years']['whoWillSendReminder'] = []
                        }

                        if (this.checkProperty(this.config['reminders']['visaExpiry']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['visaExpiry']['whoWillSendReminder'] = this.config['reminders']['visaExpiry']['whoWillSendReminder']
                        }else{
                            this.config['reminders']['visaExpiry']['whoWillSendReminder'] = []
                        }
                        if (this.checkProperty(this.config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder'], 'length') > 0) {
                            this.config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder'] = this.config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder']
                        }else{
                            this.config['reminders']['i140ApprovedDuringDays']['whoWillSendReminder'] = []
                        }
                        if (this.checkProperty(this.config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder'], 'length') > 0) {

                            this.config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder'] = this.config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder']

                        }else{
                            this.config['reminders']['gcEmpi485ApprovedDays']['whoWillSendReminder'] = []
                        }

                        if (this.checkProperty(this.config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder'], 'length') > 0) {

                            this.config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder'] = this.config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder']

                        }else{
                            this.config['reminders']['i130ApprovedDuringDays']['whoWillSendReminder'] = []
                        }

                        if (this.checkProperty(this.config['reminders']['gcfamilyi485ApprovedDays']['whoWillSendReminder'], 'length') > 0) {

                            this.config['reminders']['gcfamilyi485ApprovedDays']['whoWillSendReminder'] = this.config['reminders']['gcfamilyi485ApprovedDays']['whoWillSendReminder']

                        }else{
                            this.config['reminders']['gcfamilyi485ApprovedDays']['whoWillSendReminder'] = []
                        }

                        if (this.checkProperty(this.config['reminders']['priorToExpiryl1aOrl1b']['whoWillSendReminder'], 'length') > 0) {

                            this.config['reminders']['priorToExpiryl1aOrl1b']['whoWillSendReminder'] = this.config['reminders']['priorToExpiryl1aOrl1b']['whoWillSendReminder']

                        }else{
                            this.config['reminders']['priorToExpiryl1aOrl1b']['whoWillSendReminder'] = []
                        }

                        if (this.checkProperty(this.config['reminders']['l1i140ApprovedDuringDays']['whoWillSendReminder'], 'length') > 0) {

                            this.config['reminders']['l1i140ApprovedDuringDays']['whoWillSendReminder'] = this.config['reminders']['l1i140ApprovedDuringDays']['whoWillSendReminder']

                        }else{
                            this.config['reminders']['l1i140ApprovedDuringDays']['whoWillSendReminder'] =[]
                        }

                        if (_.has(this.config['reminders'], 'globalStatus') && this.checkProperty(this.config['reminders'], 'globalStatus') && this.checkProperty(this.config['reminders'], 'globalStatus', 'length')>0) {
                            _.forEach(this.config['reminders']['globalStatus'], (item) => {
                                if(this.checkProperty(item, 'config', 'length')>0){
                                    _.forEach(item['config'], (it) => {
                                        it['showError'] = false
                                    })
                                }else{
                                    item['config'] = [{ days: '', showError: false }]
                                }
                            })
                            this.updateCountryList();
                        }else{
                            this.config['reminders']['globalStatus'] = [{
                                countryId: null,
                                countryDetails: null,
                                config: [{ days: '', showError: false }]
                            }];
                            this.updateCountryList();
                        }
                        
                    }
                   

                    if (this.config['reminders']['pwdExpiry']['config'].length <= 0) {
                        this.config['reminders']['pwdExpiry']['config'] = [{ days: '', showError: false }]
                    }

                    if (this.config['reminders']['i140']['config'].length <= 0) {

                        this.config['reminders']['i140']['config'] = [{ days: '', showError: false }]

                    }
                    if (this.config['reminders']['sponQuestionnire']['config'].length <= 0) {
                        this.config['reminders']['sponQuestionnire']['config'] = [{ days: '', showError: false }]
                    }
                    if (this.config['reminders']['passportExpiry']['config'].length <= 0) {
                        this.config['reminders']['passportExpiry']['config'] = [{ days: '', showError: false }]
                    }
                    if (this.config['reminders']['i94Expiry']['config'].length <= 0) {
                        this.config['reminders']['i94Expiry']['config'] = [{ days: '', showError: false }]
                    }
                    if (this.config['reminders']['totalStayIsNearing6Years']['config'].length <= 0) {
                        this.config['reminders']['totalStayIsNearing6Years']['config'] = [{ days: '', showError: false }]
                    }
                    if (this.config['reminders']['workAuthorizationExpiry']['config'].length <= 0) {
                        this.config['reminders']['workAuthorizationExpiry']['config'] = [{ days: '', showError: false }]
                    }
                    if (this.config['reminders']['visaExpiry']['config'].length <= 0) {
                        this.config['reminders']['visaExpiry']['config'] = [{ days: '', showError: false }]
                    }
                    if (this.config['reminders']['caseSeleByUscisInLotteryDays']['config'].length <= 0) {

                        this.config['reminders']['caseSeleByUscisInLotteryDays']['config'] = [{ days: '', showError: false }]

                    } 
                    if (this.config['reminders']['invoicePaymentReminder']['config'].length <= 0) {

                        this.config['reminders']['invoicePaymentReminder']['config'] = [{ days: '', showError: false }];
                    }
                    if (this.config['reminders']['priorToExpiryDaysH1b']['config'].length <= 0) {

                        this.config['reminders']['priorToExpiryDaysH1b']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['config'].length <= 0) {

                        this.config['reminders']['lcaSubAndQuestNotSubBriefDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['pwdCertOrBeforeExpiryDays']['config'].length <= 0) {

                        this.config['reminders']['pwdCertOrBeforeExpiryDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['lastAdvReleaseBriefDays']['config'].length <= 0) {

                        this.config['reminders']['lastAdvReleaseBriefDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['priorToExpiryPermDays']['config'].length <= 0) {

                        this.config['reminders']['priorToExpiryPermDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['i140ApprovedDuringDays']['config'].length <= 0) {

                        this.config['reminders']['i140ApprovedDuringDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['gcEmpi485ApprovedDays']['config'].length <= 0) {

                        this.config['reminders']['gcEmpi485ApprovedDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['i130ApprovedDuringDays']['config'].length <= 0) {

                        this.config['reminders']['i130ApprovedDuringDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['gcfamilyi485ApprovedDays']['config'].length <= 0) {

                        this.config['reminders']['gcfamilyi485ApprovedDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['priorToExpiryl1aOrl1b']['config'].length <= 0) {

                        this.config['reminders']['priorToExpiryl1aOrl1b']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.config['reminders']['l1i140ApprovedDuringDays']['config'].length <= 0) {

                        this.config['reminders']['l1i140ApprovedDuringDays']['config'] = [{ days: '', showError: false }]

                    }

                    if (this.checkProperty(this.configDetails, 'config', 'handlePwdActivityUsers')) {

                        this.processHandlePwdActivityUsers();

                        // handlePwdActivityUsers 

                    }

                    if (_.has(this.configDetails['config'], 'whoWillReassignCase') && this.checkProperty(this.configDetails, 'config', 'whoWillReassignCase')) {

                        this.processwhoWillReassignCase();

                    } else {

                        let findObj = _.find(this.allUserRoles, { "id": 3 })

                        if (findObj) {

                            this.configDetails['config']['whoWillReassignCase'].push(findObj)

                        }

                    }



                })





        },

        processwhoWillReassignCase() {

            if (this.checkProperty(this.configDetails, 'config', 'whoWillReassignCase') && this.checkProperty(this.configDetails['config'], 'whoWillReassignCase', 'length') > 0) {

                this.config['whoWillReassignCase'] = _.filter(this.allUserRoles, (rol) => {

                    return this.configDetails['config']['whoWillReassignCase'].indexOf(rol['id']) > -1

                })



            } else {

                let findObj = _.find(this.allUserRoles, { "id": 3 })

                if (findObj) {

                    this.configDetails['config']['whoWillReassignCase'].push(findObj)

                    this.config['whoWillReassignCase'].push(findObj)



                }

            }

        },

        processHandlePwdActivityUsers() {





            if (this.checkProperty(this.configDetails, 'config', 'handlePwdActivityUsers')) {

                this.config['handlePwdActivityUsers'] = _.filter(this.allUserRoles, (rol) => {

                    return this.configDetails['config']['handlePwdActivityUsers'].indexOf(rol['id']) > -1

                })



            }

        },

        getTimeZoneList() {

            let postData = {

                page: 1,

                perpage: 1000,

                category: "timezone"

            }

            this.$store.dispatch("getMasterData", postData).then((res) => {

                _.forEach(res['list'], (item) => {

                    item.name = item['name'] + ' (' + item.id + ')';

                    this.timeZoneList.push(item);



                })



                this.getGlobalConfigDetails();



            })

        }



    },



    mounted() {
        this.$store.dispatch("getcountries").then((response) => {
            this.countries = response;
            this.filteredCountries = response
        });
        this.getGraduatedYears();

        this.getAllSeasonsList();

        this.getUserRoles();

        this.username = this.$store.state.user.name;

        this.roleId = this.$store.state.user["roleId"][0];

        this.getCourierList();

        this.getTimeZoneList()







    },

    computed: {

        selectedSeasonYear() {

            return (data) => {

                let retrunVal = null;

                let year = parseInt(data)

                if (year && year > 2) {

                    let dt = parseInt(year) - 2

                    let date = dt + '-04-01';

                    retrunVal = date;

                }

                return retrunVal

            }

        },

        showMoreBtn() {

            return (category) => {
               
                if(['workAuthorizationExpiry','passportExpiry','i94Expiry','visaExpiry','totalStayIsNearing6Years'].indexOf(category) > -1){
                    let itemLength = this.checkProperty(this.config['reminders'][category]['config'], 'length');
                    let lastIndexx = parseInt(itemLength) - 1;
                    if (this.checkProperty(this.config['reminders'][category]['config'][lastIndexx], 'days') == 1) {
                        return false
                    } else {
                        return true
                    }
                }

                if (category == 'pwdExpiry') {

                    let itemLength = this.checkProperty(this.config['reminders'][category]['config'], 'length');

                    let lastIndexx = parseInt(itemLength) - 1;

                    if (this.checkProperty(this.config['reminders'][category]['config'][lastIndexx], 'days') == 1 || this.checkProperty(this.config['reminders'][category]['config'][lastIndexx], 'days') == 0) {

                        return false

                    } else {

                        return true

                    }

                }

                else {

                    let itemLength = this.checkProperty(this.config['reminders'][category]['config'], 'length');

                    let lastIndexx = parseInt(itemLength) - 1;

                    if (this.checkProperty(this.config['reminders'][category]['config'][lastIndexx], 'days') == 999) {

                        return false

                    } else {

                        return true

                    }



                }



            }

        },
        showMoreGlobalBtn() {
            return (inde) => {
                let itemLength = this.checkProperty(this.config['reminders']['globalStatus'][inde]['config'], 'length');
                let lastIndexx = parseInt(itemLength) - 1;
                if ([0, '0'].indexOf(this.checkProperty(this.config['reminders']['globalStatus'][inde]['config'][lastIndexx], 'days'))>-1) {
                    return false
                } else {
                    return true
                }
            }
        },

        getMaxValue() {

            return (index) => {

                if (index > 0) {

                    let item = this.config['reminders']['pwdExpiry']['config'][index - 1];

                    if (_.get(item, 'days')) {

                        let days = _.get(item, 'days')

                        return parseInt(days) - 1;

                    } else {

                        return null

                    }

                } else {

                    return null

                }

            }

        },
        getPermMaxValue() {

return (index) => {

    if (index > 0) {

        let item = this.config['reminders']['priorToExpiryPermDays']['config'][index - 1];

        if (_.get(item, 'days')) {

            let days = _.get(item, 'days')

            return parseInt(days) - 1;

        } else {

            return null

        }

    } else {

        return null

    }

}

}

    }

};

</script> 